
import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import { GestionarTipoProducto } from "./gestionarTipoProducto";
import { GestionarMarca } from "./gestionarMarca";
import { GestionarModelo } from "./gestionarModelo";
import {
  formatMoneda,
  validaMonto,
  formatoMonto,
  formatoMonto3,
  seleccionarCampo,
  onCambioMoneda,
  round,
  formatearMonto,
} from "../../util/varios";
import { GestionarMedida } from "./gestionarUnidadMedida";
import { GestionarFabricantes } from "./gestionarFabricante";
import { GestionarClasificadorVacios } from "../vacios/gestionarClasificadorVacios";

export const ModalEditarProductosOperacion = (props) => {

  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtnproducto = JSON.parse(sessionStorage.getItem("accbtnproductoc"));
  /* bloquear tab */
  const [tabIndex, setTabIndex] = useState({ tab1: "tab", tab2: "" });
  /* activar tab */
  const [activeTab, setACtiveTab] = useState({
    tab1: "nav-link active text-light bg-blue-100 rounded",
    tab2: "nav-link text-light bg-blue-200 rounded",
  });
  /* mostar tabPanel */
  const [tabPanel, setTabPanel] = useState({
    tab1: "tab-pane fade show active",
    tab2: "tab-pane fade",
  });
  /* validar tab */
  const [tabvalid, setTabValid] = useState({ tab1: "true", tab2: "false" });

  const [alerta, setAlerta] = useState({
    max: 0,
    ofe: 0,
    may: 0,
    min: 0,
    maxalt: 0,
    ofealt: 0,
    mayalt: 0,
    minalt: 0,
  });

  const btnIncluir = useRef();
  const btnEditar = useRef();
  const btnEliminar = useRef();
  const btnConsultar = useRef();
  const btnAceptar = useRef();
  const btnCancelar = useRef();
  const txtIdproducto = useRef();
  const txtIdproductoHidden = useRef();
  //const txtCodigo = useRef();
  const txtNombre = useRef();
  const txtNombreCorto = useRef();
  const cmbMarca = useRef();
  const cmbModelo = useRef();
  const cmbMoneda = useRef();
  const cmbTipoProd = useRef();
  const cmbFabricante = useRef();
  const txtReferencia = useRef();
  const txtDiasGar = useRef();
  const cmbUnidMedida = useRef();
  const txtCostoProveSinImp = useRef();
  const txtCostoCalcuSinImp = useRef();
  const txtUltimoCostoSinImp = useRef();
  const txtCostoPromeSinImp = useRef();
  const cmbMetodoCosto = useRef();
  const cmbPrecioVenta = useRef();
  const txtCostoProveConImp = useRef();
  const txtCostoCalcuConImp = useRef();
  const txtUltimoCostoConImp = useRef();
  const txtCostoPromeConImp = useRef();
  const txtIvaCompra = useRef();
  const txtIvaVenta = useRef();
  const txtPrecioMaxiSinImp = useRef();
  const txtPrecioOfeSinImp = useRef();
  const txtPrecioMayorSinImp = useRef();
  const txtPrecioMiniSinImp = useRef();
  const txtUtilidadMaxi = useRef();
  const txtUtilidadOfe = useRef();
  const txtUtilidadMayor = useRef();
  const txtUtilidadMini = useRef();
  const txtPrecioMaxiConImp = useRef();
  const txtPrecioOfeConImp = useRef();
  const txtPrecioMayorConImp = useRef();
  const txtPrecioMiniConImp = useRef();
  const radioSi = useRef();
  const radioNo = useRef();
  const chkServicio = useRef();
  const txtVacio = useRef();
  const txtCodigoVacio = useRef();
  const txtStockMini = useRef();
  const cmbUniVenta = useRef();
  const cmbUniCompra = useRef();
  const cmbUniPrincipal = useRef();
  const cmbUniAlterna = useRef();
  const cmbAlmacen = useRef();
  const txtFactor = useRef();
  const cmbUniFactor = useRef();
  const txtCostoProveSinImpAlter = useRef();
  const txtCostoCalcuSinImpAlter = useRef();
  const txtUltimoCostoSinImpAlter = useRef();
  const txtCostoPromeSinImpAlter = useRef();
  const txtCostoProveConImpAlter = useRef();
  const txtCostoCalcuConImpAlter = useRef();
  const txtUltimoCostoConImpAlter = useRef();
  const txtCostoPromeConImpAlter = useRef();
  const txtPrecioMaxiSinImpAlter = useRef();
  const txtPrecioOfeSinImpAlter = useRef();
  const txtPrecioMayorSinImpAlter = useRef();
  const txtPrecioMiniSinImpAlter = useRef();
  const txtUtilidadMaxiAlter = useRef();
  const txtUtilidadOfeAlter = useRef();
  const txtUtilidadMayorAlter = useRef();
  const txtUtilidadMiniAlter = useRef();
  const txtPrecioMaxiConImpAlter = useRef();
  const txtPrecioOfeConImpAlter = useRef();
  const txtPrecioMayorConImpAlter = useRef();
  const txtPrecioMiniConImpAlter = useRef();

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [body, setBody] = useState(false);
  const [habilitadoAlter, setHabilitadoAlter] = useState(false);
  const [visibleA, setVisibleA] = useState("visible");
  const [costoSelect, setCostoSelect] = useState("1");
  const [precioSelect, setPrecioSelect] = useState("1");
  const [flujo, setFlujo] = useState([
    "0",
    "10",
    "20",
    "30",
    "40",
    "50",
    "60",
    "70",
    "80",
    "90",
    "100",
  ]);

  const [mostrarMarca, setMostrarMarca] = useState(false);
  const [mostrarModelo, setMostrarModelo] = useState(false);
  const [mostrarTipoP, setMostrarTipoP] = useState(false);
  const [mostrarFabricante, setMostrarFabricante] = useState(false);
  const [mostrarclassvacio, setMostrarclassvacio] = useState(false);
  const [mostrarMedida, setMostrarMedida] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [valvacio, setValvacio] = useState(0);
  const [unidadM, setUnidadM] = useState([]);
  const [classvacios, setClassvacios] = useState([]);
  const [tipoP, setTipoP] = useState([]);
  const [fabri, setFabri] = useState([]);
  const [marca, setMarca] = useState([]);
  const [modelo, setModelo] = useState([]);
  const [unidadV, setUnidadV] = useState([]);
  const [unidadC, setUnidadC] = useState([]);
  const [factor, setFactor] = useState([]);
  const [combomoneda, setComboMoneda] = useState([]);
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [imagen, setImagen] = useState({
    imagen: "subir.png",
    imagenactual: "subir.png",
  });
  const [pathImage, setPathImage] = useState({
    imagen: `${op.conexion}/imagen?img=subir.png`,
  });
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [producto, setProducto] = useState({
    idproducto: "",
    codigo: "",
    nombre: "",
    preciomax: "",
    unidadalterna: "",
    unidadmedida: "",
  });

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let x = 0;
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
                setMonedaCambio({
                  idmoneda: response.data[i].idmoneda,
                  descripcion: response.data[i].descripcion,
                  simbolo: response.data[i].simbolo,
                  predeterminada: response.data[i].predeterminada,
                  subpredeterminada: response.data[i].subpredeterminada,
                  valormoneda: 1.0,
                });
                x = i;
              } else if (response.data[i].predeterminada) {
                setMoneda(response.data[i]);
              }
            }
            seleccionarUnidadMedida(props.ope);
          }
          setTimeout(() => (cmbMoneda.current.selectedIndex = x), 200);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarTipoProd = () => {
    let campos = "*";
    let nomtab = "tipoproducto";
    let orden = "descripcion";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setTipoP(response.data);
          cmbTipoProd.current.selectedIndex = -1;
        }
        seleccionarFabricante();
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarFabricante = () => {
    let campos = "*";
    let nomtab = "fabricante";
    let orden = "descripcion";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setFabri(response.data);
          cmbFabricante.current.selectedIndex = -1;
        }
        seleccionarMarca();
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarUnidadMedida = (ope) => {
    let campos = "*";
    let nomtab = "unidadmedida";
    let orden = "idunidadmedida";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setUnidadM(response.data);
          if (ope === 1) {
            cmbUniPrincipal.current.selectedIndex = 0;
            cmbUnidMedida.current.selectedIndex = 0;
          } else {
            cmbUniPrincipal.current.selectedIndex = -1;
            cmbUnidMedida.current.selectedIndex = -1;
          }
          cmbUniAlterna.current.selectedIndex = -1;
        }
        seleccionarTipoProd();
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const agregarUnidad = () => {
    seleccionarUnidadMedida(1);
  };

  const seleccionarClassVacios = (ope, idclas) => {
    let campos = "*";
    let nomtab = "clasevacio";
    let orden = "idclasevacio";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setClassvacios(response.data);
          txtCodigoVacio.current.selectedIndex = -1;
          if (ope === 1) {
            txtCodigoVacio.current.value = idclas;
          } else {
            txtCodigoVacio.current.value = "";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarMarca = () => {
    let campos = "*";
    let nomtab = "marca";
    let orden = "descripcion";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMarca(response.data);
          cmbMarca.current.selectedIndex = 0;
        }
        seleccionarModelo();
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarModelo = () => {
    let campos = "*";
    let nomtab = "modelo";
    let orden = "descripcion";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setModelo(response.data);
          cmbModelo.current.selectedIndex = 0;
          if (response.data !== '') {
            seleccionarRegistro(props.idproduct);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const abrirModal = (tipo) => (e) => {
    e.preventDefault();
    if (tipo === "marca") {
      setMostrarMarca(true);
    } else if (tipo === "modelo") {
      setMostrarModelo(true);
    } else if (tipo === "tipop") {
      setMostrarTipoP(true);
    } else if (tipo === "medida") {
      setMostrarMedida(true);
    } else if (tipo === "fabricante") {
      setMostrarFabricante(true);
    } else if (tipo === "classvacios") {
      setMostrarclassvacio(true);
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setFlujo([
      "0",
      "10",
      "20",
      "30",
      "40",
      "50",
      "60",
      "70",
      "80",
      "90",
      "100",
    ]);
    setValvacio(0);
    setActivate(false);
    setBody();
    setHabilitado(false);
    setUnidadM([]);
    setTipoP([]);
    setFabri([]);
    setMarca([]);
    setModelo([]);
    setAlerta({
      max: 0,
      ofe: 0,
      may: 0,
      min: 0,
      maxalt: 0,
      ofealt: 0,
      mayalt: 0,
      minalt: 0,
    });
    setCostoSelect("1");
    setPrecioSelect("1");
    setMonedaCambio({
      idmoneda: "4",
      descripcion: "DOLAR",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 1.0,
    });

    for (let i = 0; i < combomoneda.length; i++) {
      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
        cmbMoneda.current.selectedIndex = i;
      }
    }
    setVisibleBtn("visible");
    txtIdproducto.current.value = "";
    txtVacio.current.checked = false;
    txtNombre.current.value = "";
    txtNombreCorto.current.value = "";
    txtReferencia.current.value = "";
    txtDiasGar.current.value = "";
    txtIvaCompra.current.value = "";
    txtIvaVenta.current.value = "";
    txtCostoProveSinImp.current.value = "";
    txtCostoCalcuSinImp.current.value = "";
    txtUltimoCostoSinImp.current.value = "";
    txtCostoPromeSinImp.current.value = "";
    txtCostoProveConImp.current.value = "";
    txtCostoCalcuConImp.current.value = "";
    txtUltimoCostoConImp.current.value = "";
    txtCostoPromeConImp.current.value = "";
    txtPrecioMaxiSinImp.current.value = "";
    txtPrecioOfeSinImp.current.value = "";
    txtPrecioMayorSinImp.current.value = "";
    txtPrecioMiniSinImp.current.value = "";
    txtPrecioMaxiSinImp.current.style.color = "#000000";
    txtPrecioOfeSinImp.current.style.color = "#000000";
    txtPrecioMayorSinImp.current.style.color = "#000000";
    txtPrecioMiniSinImp.current.style.color = "#000000";
    txtPrecioMaxiConImp.current.value = "";
    txtPrecioOfeConImp.current.value = "";
    txtPrecioMayorConImp.current.value = "";
    txtPrecioMiniConImp.current.value = "";
    txtUtilidadMaxi.current.value = "";
    txtUtilidadOfe.current.value = "";
    txtUtilidadMayor.current.value = "";
    txtUtilidadMini.current.value = "";
    chkServicio.current.checked = false;
    cmbAlmacen.current.value = "true";
    txtStockMini.current.value = "0,00";
    setVisibleA("visible");
    cmbPrecioVenta.current.value = "1";
    cmbMetodoCosto.current.value = "1";
    cmbMarca.current.selectedIndex = -1;
    cmbModelo.current.selectedIndex = -1;

    radioSi.current.checked = false;
    radioNo.current.checked = false;
  };

  const blanquearAlter = () => {
    setValvacio(0);
    setAlerta({
      ...alerta,
      maxalt: 0,
      ofealt: 0,
      mayalt: 0,
      minalt: 0,
    });
    setHabilitadoAlter(false);
    txtCostoProveSinImpAlter.current.value = "";
    txtCostoCalcuSinImpAlter.current.value = "";
    txtUltimoCostoSinImpAlter.current.value = "";
    txtCostoPromeSinImpAlter.current.value = "";
    txtCostoProveConImpAlter.current.value = "";
    txtCostoCalcuConImpAlter.current.value = "";
    txtUltimoCostoConImpAlter.current.value = "";
    txtCostoPromeConImpAlter.current.value = "";
    txtPrecioMaxiSinImpAlter.current.value = "";
    txtPrecioOfeSinImpAlter.current.value = "";
    txtPrecioMayorSinImpAlter.current.value = "";
    txtPrecioMiniSinImpAlter.current.value = "";
    txtPrecioMaxiConImpAlter.current.value = "";
    txtPrecioOfeConImpAlter.current.value = "";
    txtPrecioMayorConImpAlter.current.value = "";
    txtPrecioMiniConImpAlter.current.value = "";
    txtUtilidadMaxiAlter.current.value = "";
    txtUtilidadOfeAlter.current.value = "";
    txtUtilidadMayorAlter.current.value = "";
    txtUtilidadMiniAlter.current.value = "";
    txtFactor.current.value = "";
    txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
    txtPrecioOfeSinImpAlter.current.style.color = "#000000";
    txtPrecioMayorSinImpAlter.current.style.color = "#000000";
    txtPrecioMiniSinImpAlter.current.style.color = "#000000";
    txtVacio.current.checked = false;
    setFactor([]);
    setUnidadC([]);
    setUnidadV([]);
    cmbUniPrincipal.current.selectedIndex = -1;
    cmbUniAlterna.current.selectedIndex = -1;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);

    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }

      if (event.target.id === "costoProveSinImpu") {
        calcularImpuestosCostos();
        if (event.which === 13) {
          txtCostoCalcuSinImp.current.focus();
        }
      } else if (event.target.id === "costoCalcuSinImpu") {
        calcularImpuestosCostos();
        if (event.which === 13) {
          txtUltimoCostoSinImp.current.focus();
        }
      } else if (event.target.id === "costoUltiSinImpu") {
        calcularImpuestosCostos();
        if (event.which === 13) {
          txtCostoPromeSinImp.current.focus();
        }
      } else if (event.target.id === "costoPromeSinImpu") {
        calcularImpuestosCostos();
        if (event.which === 13) {
          txtPrecioMaxiSinImp.current.focus();
        }
      } else if (event.target.id === "preciomaximo") {
        calcularUtilidadxValor(1);
        if (event.which === 13) {
          txtPrecioOfeSinImp.current.focus();
        }
      } else if (event.target.id === "preciooferta") {
        calcularUtilidadxValor(2);
        if (event.which === 13) {
          txtPrecioMayorSinImp.current.focus();
        }
      } else if (event.target.id === "preciomayor") {
        calcularUtilidadxValor(3);
        if (event.which === 13) {
          txtPrecioMiniSinImp.current.focus();
        }
      } else if (event.target.id === "preciominimo") {
        calcularUtilidadxValor(4);
      } else if (event.target.id === "utilidadMaxi") {
        calcularUtilidadxPorce(1);
      } else if (event.target.id === "utilidadOfe") {
        calcularUtilidadxPorce(2);
      } else if (event.target.id === "utilidadMayor") {
        calcularUtilidadxPorce(3);
      } else if (event.target.id === "utilidadMini") {
        calcularUtilidadxPorce(4);
      } else if (event.target.id === "costoProveSinImpuAlter") {
        calcularImpuestosCostosAlter();
        if (event.which === 13) {
          txtCostoCalcuSinImpAlter.current.focus();
        }
      } else if (event.target.id === "costoCalcuSinImpuAlter") {
        calcularImpuestosCostosAlter();
        if (event.which === 13) {
          txtUltimoCostoSinImpAlter.current.focus();
        }
      } else if (event.target.id === "costoUltiSinImpuAlter") {
        calcularImpuestosCostosAlter();
        if (event.which === 13) {
          txtCostoPromeSinImpAlter.current.focus();
        }
      } else if (event.target.id === "costoPromeSinImpuAlter") {
        calcularImpuestosCostosAlter();
        if (event.which === 13) {
          txtUtilidadMaxiAlter.current.focus();
        }
      } else if (event.target.id === "preciomaximoalter") {
        calcularUtilidadxValorAlter(1);
      } else if (event.target.id === "precioofertaalter") {
        calcularUtilidadxValorAlter(2);
      } else if (event.target.id === "preciomayoralter") {
        calcularUtilidadxValorAlter(3);
      } else if (event.target.id === "preciominialter") {
        calcularUtilidadxValorAlter(4);
      } else if (event.target.id === "utilidadMaxiAlter") {
        calcularUtilidadAlter(1);
      } else if (event.target.id === "utilidadOfeAlter") {
        calcularUtilidadAlter(2);
      } else if (event.target.id === "utilidadMayorAlter") {
        calcularUtilidadAlter(3);
      } else if (event.target.id === "utilidadMiniAlter") {
        calcularUtilidadAlter(4);
      } else if (event.target.id === "ivaCompra") {
        calcularImpuestosCostos();
        if (cmbUniFactor.current.selectedIndex >= 0) {
          calcularFactorConversion();
          calcularImpuestosCostosAlter();
        }
        if (event.which === 13) {
          txtIvaVenta.current.focus();
        }
      } else if (event.target.id === "ivaVenta") {
        calcularUtilidadxValor(5);
        if (cmbUniFactor.current.selectedIndex >= 0) {
          calcularFactorConversion();
          calcularImpuestosCostosAlter();
        }
      } else if (event.target.id === "stockminimo") {
        txtCostoProveSinImp.current.focus();
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      if (event.target.id === "inputCodigo") {
        txtNombre.current.focus();
      } else if (event.target.id === "inputNombre") {
        txtReferencia.current.focus();
      } else if (event.target.id === "inputRefe") {
        txtNombreCorto.current.focus();
      } else if (event.target.id === "inputNombreCorto") {
        cmbTipoProd.current.focus();
      } else if (event.target.id === "inputDiasGar") {
        cmbMarca.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      return false;
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const calcularImpuestosCostos = () => {
    let costoProv = 0.0,
      costoCal = 0.0,
      costoUlt = 0.0,
      costoProm = 0.0;
    let valIva =
      parseFloat(
        txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")
      ) / 100;

    if (txtCostoProveSinImp.current.value.trim() !== "") {
      costoProv =
        (1 + valIva) *
        parseFloat(
          txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );
      txtCostoProveConImp.current.value = formatMoneda(
        costoProv.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtCostoCalcuSinImp.current.value.trim() !== "") {
      costoCal =
        (1 + valIva) *
        parseFloat(
          txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );
      txtCostoCalcuConImp.current.value = formatMoneda(
        costoCal.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtUltimoCostoSinImp.current.value.trim() !== "") {
      costoUlt =
        (1 + valIva) *
        parseFloat(
          txtUltimoCostoSinImp.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );
      txtUltimoCostoConImp.current.value = formatMoneda(
        costoUlt.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtCostoPromeSinImp.current.value.trim() !== "") {
      costoProm =
        (1 + valIva) *
        parseFloat(
          txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );
      txtCostoPromeConImp.current.value = formatMoneda(
        costoProm.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    calcularPrecioSinImpuestos();
  };

  const calcularPrecioSinImpuestos = () => {
    let mon = "0,00";

    if (cmbMetodoCosto.current.value === "1") {
      mon = txtCostoProveSinImp.current.value;
    }

    if (cmbMetodoCosto.current.value === "2") {
      mon = txtCostoCalcuSinImp.current.value;
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = txtUltimoCostoSinImp.current.value;
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = txtCostoPromeSinImp.current.value;
    }

    txtPrecioMaxiSinImp.current.value = mon;
    txtPrecioOfeSinImp.current.value = mon;
    txtPrecioMayorSinImp.current.value = mon;
    txtPrecioMiniSinImp.current.value = mon;

    calcularUtilidadxValor(5);
  };

  const calcularPrecioSinImpuestosAlter = () => {
    let mon = "0,00";

    if (cmbMetodoCosto.current.value === "1") {
      mon = txtCostoProveSinImpAlter.current.value;
    }

    if (cmbMetodoCosto.current.value === "2") {
      mon = txtCostoCalcuSinImpAlter.current.value;
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = txtUltimoCostoSinImpAlter.current.value;
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = txtCostoPromeSinImpAlter.current.value;
    }

    txtPrecioMaxiSinImpAlter.current.value = mon;
    txtPrecioOfeSinImpAlter.current.value = mon;
    txtPrecioMayorSinImpAlter.current.value = mon;
    txtPrecioMiniSinImpAlter.current.value = mon;

    calcularUtilidadxValorAlter(5);
    calcularImpuestosVentasAlter();
  };

  const calcularImpuestosVentas = () => {
    let costo = 0.0;
    let uti = 0.0;
    let monto = 0.0;
    let valIva =
      parseFloat(
        txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")
      ) / 100;

    if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
      let costoMaxi = costo;
      if (costoMaxi <= 0.0) {
        costoMaxi = parseFloat(
          txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        monto = (1 + valIva) * costoMaxi;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")
          ) *
            costoMaxi) /
          100;
        monto = (1 + valIva) * costoMaxi; //+ uti;
      }

      txtPrecioMaxiConImp.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtPrecioOfeSinImp.current.value.trim() !== "") {
      let costoOfe = costo;
      if (costoOfe <= 0.0) {
        costoOfe = parseFloat(
          txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        monto = (1 + valIva) * costoOfe;
      } else {
        uti =
          (parseFloat(
            txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")
          ) *
            costoOfe) /
          100;
        monto = (1 + valIva) * costoOfe; // + uti;
      }

      txtPrecioOfeConImp.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtPrecioMayorSinImp.current.value.trim() !== "") {
      let costoMayor = costo;
      if (costoMayor <= 0.0) {
        costoMayor = parseFloat(
          txtPrecioMayorSinImp.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        monto = (1 + valIva) * costoMayor;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")
          ) *
            costoMayor) /
          100;
        monto = (1 + valIva) * costoMayor; //+ uti;
      }

      txtPrecioMayorConImp.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtPrecioMiniSinImp.current.value.trim() !== "") {
      let costoMini = costo;
      if (costoMini <= 0.0) {
        costoMini = parseFloat(
          txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        monto = (1 + valIva) * costoMini;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")
          ) *
            costoMini) /
          100;
        monto = (1 + valIva) * costoMini; //+ uti;
      }

      txtPrecioMiniConImp.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }

    if (radioSi.current.checked) {
      calcularPrecioSinImpuestosAlter();
    }
  };

  const calcularUtilidadxValor = (desde) => {
    let mon = 0.0;
    let mon2 = 0.0;
    let utiMax = 0.0,
      utiOfe = 0.0,
      utiMay = 0.0,
      utiMin = 0.0;
    if (cmbMetodoCosto.current.value === "1") {
      mon = parseFloat(
        txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "2") {
      mon = parseFloat(
        txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = parseFloat(
        txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = parseFloat(
        txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    switch (desde) {
      case 1:
        mon2 = parseFloat(
          txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            utiMax = (mon2 - mon) / mon;
            utiMax = utiMax * 100;
          } else {
            utiMax = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
          txtUtilidadMaxi.current.value = formatMoneda(
            utiMax.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
        break;
      case 2:
        mon2 = parseFloat(
          txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            utiOfe = (mon2 - mon) / mon;
            utiOfe = utiOfe * 100;
          } else {
            utiOfe = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioOfeSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImp.current.style.color = "#000000";
        }

        if (txtPrecioOfeSinImp.current.value.trim() !== "") {
          txtUtilidadOfe.current.value = formatMoneda(
            utiOfe.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
        break;
      case 3:
        mon2 = parseFloat(
          txtPrecioMayorSinImp.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            utiMay = (mon2 - mon) / mon;
            utiMay = utiMay * 100;
          } else {
            utiMay = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMayorSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMayorSinImp.current.value.trim() !== "") {
          txtUtilidadMayor.current.value = formatMoneda(
            utiMay.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
        break;
      case 4:
        mon2 = parseFloat(
          txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            utiMin = (mon2 - mon) / mon;
            utiMin = utiMin * 100;
          } else {
            utiMin = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMiniSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMiniSinImp.current.value.trim() !== "") {
          txtUtilidadMini.current.value = formatMoneda(
            utiMin.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
        break;
      case 5:
        mon2 = parseFloat(
          txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        if (mon > 0.0) {
          utiMax = (mon2 - mon) / mon;
          utiMax = utiMax * 100;
        }

        if (mon > mon2) {
          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
          txtUtilidadMaxi.current.value = formatMoneda(
            utiMax.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        mon2 = parseFloat(
          txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        if (mon > 0.0) {
          utiOfe = (mon2 - mon) / mon;
          utiOfe = utiOfe * 100;
        }

        if (mon > mon2) {
          txtPrecioOfeSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImp.current.style.color = "#000000";
        }

        if (txtPrecioOfeSinImp.current.value.trim() !== "") {
          txtUtilidadOfe.current.value = formatMoneda(
            utiOfe.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        mon2 = parseFloat(
          txtPrecioMayorSinImp.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon > 0.0) {
          utiMay = (mon2 - mon) / mon;
          utiMay = utiMay * 100;
        }

        if (mon > mon2) {
          txtPrecioMayorSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMayorSinImp.current.value.trim() !== "") {
          txtUtilidadMayor.current.value = formatMoneda(
            utiMay.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        mon2 = parseFloat(
          txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", ".")
        );

        if (mon > 0.0) {
          utiMin = (mon2 - mon) / mon;
          utiMin = utiMin * 100;
        }

        if (mon > mon2) {
          txtPrecioMiniSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImp.current.style.color = "#000000";
        }

        if (txtPrecioMiniSinImp.current.value.trim() !== "") {
          txtUtilidadMini.current.value = formatMoneda(
            utiMin.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        break;
    }
    calcularImpuestosVentas();
  };

  const calcularUtilidadxPorce = (desde) => {
    let monto = 0.0,
      valUti = 0.0;
    let mon = 0.0;
    if (cmbMetodoCosto.current.value === "1") {
      mon = parseFloat(
        txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "2") {
      mon = parseFloat(
        txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = parseFloat(
        txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = parseFloat(
        txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    switch (desde) {
      case 1:
        valUti =
          parseFloat(
            txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMaxiSinImp.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          //txtUtilidadOfe.current.focus();
        } else if (
          parseFloat(
            txtPrecioMaxiSinImp.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) <= 0.0
        ) {
          txtUtilidadMaxi.current.value = "0,00";
          txtPrecioMaxiSinImp.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Maximo no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMaxi.current.value = "100,00";
          //txtUtilidadOfe.current.focus();
        }

        if (mon > monto) {
          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImp.current.style.color = "#000000";
        }

        break;
      case 2:
        valUti =
          parseFloat(
            txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioOfeSinImp.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          //txtUtilidadMayor.current.focus();
        } else if (
          parseFloat(
            txtPrecioOfeSinImp.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) <= 0.0
        ) {
          txtUtilidadOfe.current.value = "0,00";
          txtPrecioOfeSinImp.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Oferta no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadOfe.current.value = "100,00";
          //txtUtilidadMayor.current.focus();
        }

        if (mon > monto) {
          txtPrecioOfeSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImp.current.style.color = "#000000";
        }

        break;
      case 3:
        valUti =
          parseFloat(
            txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMayorSinImp.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          //txtUtilidadMini.current.focus();
        } else if (
          parseFloat(
            txtPrecioMayorSinImp.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) <= 0.0
        ) {
          txtUtilidadMayor.current.value = "0,00";
          txtPrecioMayorSinImp.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Mayor no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMayor.current.value = "100,00";
          //txtUtilidadMini.current.focus();
        }

        if (mon > monto) {
          txtPrecioMayorSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImp.current.style.color = "#000000";
        }

        break;
      case 4:
        valUti =
          parseFloat(
            txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMiniSinImp.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          //radioNo.current.focus();
        } else if (
          parseFloat(
            txtPrecioMiniSinImp.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) <= 0.0
        ) {
          txtUtilidadMini.current.value = "0,00";
          txtPrecioMiniSinImp.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Minimo no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMini.current.value = "100,00";
          // radioNo.current.focus();
        }

        if (mon > monto) {
          txtPrecioMiniSinImp.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImp.current.style.color = "#000000";
        }

        break;
      case 5:
        if (mon > 0.0) {
          valUti =
            parseFloat(
              txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")
            ) / 100;

          if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMaxiSinImp.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
          valUti =
            parseFloat(
              txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")
            ) / 100;
          if (txtPrecioOfeSinImp.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioOfeSinImp.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
          valUti =
            parseFloat(
              txtUtilidadMayor.current.value
                .replace(/\./g, "")
                .replace(",", ".")
            ) / 100;
          if (txtPrecioMayorSinImp.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMayorSinImp.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
          valUti =
            parseFloat(
              txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")
            ) / 100;
          if (txtPrecioMiniSinImp.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMiniSinImp.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
        }

        break;
    }

    calcularImpuestosVentas();
  };

  const calcularFactorConversion = () => {
    let unifactor = cmbUniFactor.current.selectedIndex;
    let precio = 0.0,
      costoProv = 0.0,
      costoCal = 0.0,
      costoUlt = 0.0,
      costoProm = 0.0;
    let valor = parseFloat(
      txtFactor.current.value.replace(/\./g, "").replace(",", ".")
    );
    let mon = 0.0;

    if (cmbMetodoCosto.current.value === "1") {
      mon = parseFloat(
        txtCostoProveConImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "2") {
      mon = parseFloat(
        txtCostoCalcuConImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = parseFloat(
        txtUltimoCostoConImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = parseFloat(
        txtCostoPromeConImp.current.value.replace(/\./g, "").replace(",", ".")
      );
    }

    costoProv = parseFloat(
      txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", ".")
    );
    costoCal = parseFloat(
      txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", ".")
    );
    costoUlt = parseFloat(
      txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", ".")
    );
    costoProm = parseFloat(
      txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", ".")
    );

    if (unifactor === 0) {
      precio = mon * valor;
      costoProv = costoProv * valor;
      costoCal = costoCal * valor;
      costoUlt = costoUlt * valor;
      costoProm = costoProm * valor;
    } else {
      precio = mon / valor;
      costoProv = costoProv / valor;
      costoCal = costoCal / valor;
      costoUlt = costoUlt / valor;
      costoProm = costoProm / valor;
    }

    if (mon > 0.0) {
      txtCostoProveSinImpAlter.current.value = formatMoneda(
        costoProv.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtCostoCalcuSinImpAlter.current.value = formatMoneda(
        costoCal.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtUltimoCostoSinImpAlter.current.value = formatMoneda(
        costoUlt.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtCostoPromeSinImpAlter.current.value = formatMoneda(
        costoProm.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtPrecioMaxiSinImpAlter.current.value = formatMoneda(
        precio.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtPrecioOfeSinImpAlter.current.value = formatMoneda(
        precio.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtPrecioMayorSinImpAlter.current.value = formatMoneda(
        precio.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      txtPrecioMiniSinImpAlter.current.value = formatMoneda(
        precio.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }

    calcularImpuestosCostosAlter();
  };

  const calcularImpuestosCostosAlter = () => {
    let costoProv = 0.0,
      costoCal = 0.0,
      costoUlt = 0.0,
      costoProm = 0.0;
    let valIva =
      parseFloat(
        txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")
      ) / 100;
    if (txtCostoProveSinImpAlter.current.value.trim() !== "") {
      costoProv =
        (1 + valIva) *
        parseFloat(
          txtCostoProveSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );
      txtCostoProveConImpAlter.current.value = formatMoneda(
        costoProv.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtCostoCalcuSinImpAlter.current.value.trim() !== "") {
      costoCal =
        (1 + valIva) *
        parseFloat(
          txtCostoCalcuSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );
      txtCostoCalcuConImpAlter.current.value = formatMoneda(
        costoCal.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtUltimoCostoSinImpAlter.current.value.trim() !== "") {
      costoUlt =
        (1 + valIva) *
        parseFloat(
          txtUltimoCostoSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );
      txtUltimoCostoConImpAlter.current.value = formatMoneda(
        costoUlt.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtCostoPromeSinImpAlter.current.value.trim() !== "") {
      costoProm =
        (1 + valIva) *
        parseFloat(
          txtCostoPromeSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );
      txtCostoPromeConImpAlter.current.value = formatMoneda(
        costoProm.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    calcularPrecioSinImpuestosAlter();
  };

  const calcularImpuestosVentasAlter = () => {
    let costo = 0.0;
    let uti = 0.0;
    let monto = 0.0;
    let valIva =
      parseFloat(
        txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")
      ) / 100;

    /*     if (cmbMetodoCosto.current.value === "1") {
      costo = parseFloat(
        txtCostoProveConImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "2") {
      costo = parseFloat(
        txtCostoCalcuConImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "3") {
      costo = parseFloat(
        txtUltimoCostoConImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "4") {
      costo = parseFloat(
        txtCostoPromeConImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    } */

    if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
      let costoMaxi = costo;
      if (costoMaxi <= 0.0) {
        costoMaxi = parseFloat(
          txtPrecioMaxiSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        monto = (1 + valIva) * costoMaxi;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMaxiAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) *
            costoMaxi) /
          100;
        monto = (1 + valIva) * costoMaxi + uti;
      }

      txtPrecioMaxiConImpAlter.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
      let costoOfe = costo;
      if (costoOfe <= 0.0) {
        costoOfe = parseFloat(
          txtPrecioOfeSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        monto = (1 + valIva) * costoOfe;
      } else {
        uti =
          (parseFloat(
            txtUtilidadOfeAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) *
            costoOfe) /
          100;
        monto = (1 + valIva) * costoOfe + uti;
      }

      txtPrecioOfeConImpAlter.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
      let costoMayor = costo;
      if (costoMayor <= 0.0) {
        costoMayor = parseFloat(
          txtPrecioMayorSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        monto = (1 + valIva) * costoMayor;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMayorAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) *
            costoMayor) /
          100;
        monto = (1 + valIva) * costoMayor + uti;
      }

      txtPrecioMayorConImpAlter.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
    if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
      let costoMini = costo;
      if (costoMini <= 0.0) {
        costoMini = parseFloat(
          txtPrecioMiniSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        monto = (1 + valIva) * costoMini;
      } else {
        uti =
          (parseFloat(
            txtUtilidadMiniAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) *
            costoMini) /
          100;
        monto = (1 + valIva) * costoMini + uti;
      }

      txtPrecioMiniConImpAlter.current.value = formatMoneda(
        monto.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
    }
  };

  const calcularUtilidadAlter = (desde) => {
    let monto = 0.0,
      valUti = 0.0;
    let mon = 0.0;
    if (cmbMetodoCosto.current.value === "1") {
      mon = parseFloat(
        txtCostoProveSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "2") {
      mon = parseFloat(
        txtCostoCalcuSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = parseFloat(
        txtUltimoCostoSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = parseFloat(
        txtCostoPromeSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    switch (desde) {
      case 1:
        valUti =
          parseFloat(
            txtUtilidadMaxiAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMaxiSinImpAlter.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          //txtUtilidadOfe.current.focus();
        } else if (
          parseFloat(
            txtPrecioMaxiSinImpAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) <= 0.0
        ) {
          txtUtilidadMaxiAlter.current.value = "0,00";
          txtPrecioMaxiSinImpAlter.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Maximo no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMaxiAlter.current.value = "100,00";
          //txtUtilidadOfe.current.focus();
        }

        if (mon > monto) {
          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
        }

        break;
      case 2:
        valUti =
          parseFloat(
            txtUtilidadOfeAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioOfeSinImpAlter.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          //txtUtilidadMayor.current.focus();
        } else if (
          parseFloat(
            txtPrecioOfeSinImpAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) <= 0.0
        ) {
          txtUtilidadOfeAlter.current.value = "0,00";
          txtPrecioOfeSinImpAlter.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Oferta no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadOfeAlter.current.value = "100,00";
          //txtUtilidadMayor.current.focus();
        }

        if (mon > monto) {
          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
        }

        break;
      case 3:
        valUti =
          parseFloat(
            txtUtilidadMayorAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMayorSinImpAlter.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          //txtUtilidadMini.current.focus();
        } else if (
          parseFloat(
            txtPrecioMayorSinImpAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) <= 0.0
        ) {
          txtUtilidadMayorAlter.current.value = "0,00";
          txtPrecioMayorSinImpAlter.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Mayor no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMayorAlter.current.value = "100,00";
          //txtUtilidadMini.current.focus();
        }

        if (mon > monto) {
          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
        }

        break;
      case 4:
        valUti =
          parseFloat(
            txtUtilidadMiniAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) / 100;

        if (mon > 0.0) {
          monto = (1 + valUti) * mon;
          txtPrecioMiniSinImpAlter.current.value = formatMoneda(
            monto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          //radioNo.current.focus();
        } else if (
          parseFloat(
            txtPrecioMiniSinImpAlter.current.value
              .replace(/\./g, "")
              .replace(",", ".")
          ) <= 0.0
        ) {
          txtUtilidadMiniAlter.current.value = "0,00";
          txtPrecioMiniSinImpAlter.current.focus();
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "El Precio Minimo no puede ser 0,00.",
            icono: "informacion",
          });
        } else {
          txtUtilidadMiniAlter.current.value = "100,00";
          // radioNo.current.focus();
        }

        if (mon > monto) {
          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
        }

        break;
      case 5:
        if (mon > 0.0) {
          valUti =
            parseFloat(
              txtUtilidadMaxiAlter.current.value
                .replace(/\./g, "")
                .replace(",", ".")
            ) / 100;

          if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMaxiSinImpAlter.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
          valUti =
            parseFloat(
              txtUtilidadOfeAlter.current.value
                .replace(/\./g, "")
                .replace(",", ".")
            ) / 100;
          if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioOfeSinImpAlter.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
          valUti =
            parseFloat(
              txtUtilidadMayorAlter.current.value
                .replace(/\./g, "")
                .replace(",", ".")
            ) / 100;
          if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMayorSinImpAlter.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
          valUti =
            parseFloat(
              txtUtilidadMiniAlter.current.value
                .replace(/\./g, "")
                .replace(",", ".")
            ) / 100;
          if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
            monto = (1 + valUti) * mon;
            txtPrecioMiniSinImpAlter.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
        }

        break;
    }

    calcularImpuestosVentasAlter();
  };

  const calcularUtilidadxValorAlter = (desde) => {
    let mon = 0.0;
    if (cmbMetodoCosto.current.value === "1") {
      mon = parseFloat(
        txtCostoProveSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "2") {
      mon = parseFloat(
        txtCostoCalcuSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "3") {
      mon = parseFloat(
        txtUltimoCostoSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    if (cmbMetodoCosto.current.value === "4") {
      mon = parseFloat(
        txtCostoPromeSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      );
    }

    let mon2 = 0.0;
    let mon3 = 0.0;

    switch (desde) {
      case 1:
        mon2 = parseFloat(
          txtPrecioMaxiSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            mon3 = (mon2 - mon) / mon;
            mon3 = mon3 * 100;
          } else {
            mon3 = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMaxiAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
        break;
      case 2:
        mon2 = parseFloat(
          txtPrecioOfeSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            mon3 = (mon2 - mon) / mon;
            mon3 = mon3 * 100;
          } else {
            mon3 = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
          txtUtilidadOfeAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
        break;
      case 3:
        mon2 = parseFloat(
          txtPrecioMayorSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            mon3 = (mon2 - mon) / mon;
            mon3 = mon3 * 100;
          } else {
            mon3 = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMayorAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
        break;
      case 4:
        mon2 = parseFloat(
          txtPrecioMiniSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon2 > 0.0) {
          if (mon > 0.0) {
            mon3 = (mon2 - mon) / mon;
            mon3 = mon3 * 100;
          } else {
            mon3 = 100.0;
          }
        }

        if (mon > mon2) {
          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMiniAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
        break;
      case 5:
        mon2 = parseFloat(
          txtPrecioMaxiSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon > 0.0) {
          mon3 = (mon2 - mon) / mon;
          mon3 = mon3 * 100;
        }

        if (mon > mon2) {
          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMaxiAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        mon2 = parseFloat(
          txtPrecioOfeSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon > 0.0) {
          mon3 = (mon2 - mon) / mon;
          mon3 = mon3 * 100;
        }

        if (mon > mon2) {
          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
          txtUtilidadOfeAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        mon2 = parseFloat(
          txtPrecioMayorSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon > 0.0) {
          mon3 = (mon2 - mon) / mon;
          mon3 = mon3 * 100;
        }

        if (mon > mon2) {
          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMayorAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        mon2 = parseFloat(
          txtPrecioMiniSinImpAlter.current.value
            .replace(/\./g, "")
            .replace(",", ".")
        );

        if (mon > 0.0) {
          mon3 = (mon2 - mon) / mon;
          mon3 = mon3 * 100;
        }

        if (mon > mon2) {
          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
        } else {
          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
        }

        if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
          txtUtilidadMiniAlter.current.value = formatMoneda(
            mon3.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        break;
    }

    calcularImpuestosVentasAlter();
  };

  const unidadAlterna = (event) => {
    if (radioSi.current.checked) {
      setTabIndex({ tab1: "tab", tab2: "tab" });
      setACtiveTab({
        tab1: "nav-link text-light bg-blue-100 rounded",
        tab2: "nav-link active text-light bg-blue-200 rounded",
      });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
      setHabilitadoAlter(true);
      txtCostoProveSinImpAlter.current.value = "0,00";
      txtCostoCalcuSinImpAlter.current.value = "0,00";
      txtUltimoCostoSinImpAlter.current.value = "0,00";
      txtCostoPromeSinImpAlter.current.value = "0,00";
      txtCostoProveConImpAlter.current.value = "0,00";
      txtCostoCalcuConImpAlter.current.value = "0,00";
      txtUltimoCostoConImpAlter.current.value = "0,00";
      txtCostoPromeConImpAlter.current.value = "0,00";
      txtPrecioMaxiSinImpAlter.current.value = "0,00";
      txtPrecioOfeSinImpAlter.current.value = "0,00";
      txtPrecioMayorSinImpAlter.current.value = "0,00";
      txtPrecioMiniSinImpAlter.current.value = "0,00";
      txtPrecioMaxiConImpAlter.current.value = "0,00";
      txtPrecioOfeConImpAlter.current.value = "0,00";
      txtPrecioMayorConImpAlter.current.value = "0,00";
      txtPrecioMiniConImpAlter.current.value = "0,00";
      txtUtilidadMaxiAlter.current.value = "0,00";
      txtUtilidadOfeAlter.current.value = "0,00";
      txtUtilidadMayorAlter.current.value = "0,00";
      txtUtilidadMiniAlter.current.value = "0,00";
      txtFactor.current.value = "1,00";
      cmbUniPrincipal.current.value = cmbUnidMedida.current.value;
      cmbUniPrincipal.current.focus();
    } else {
      setTabIndex({ tab1: "tab", tab2: "" });
      setHabilitadoAlter(false);
      blanquearAlter();
    }
  };

  const manesillas = (stock, existencia) => {
    if (existencia === undefined) {
    }

    if (stock === undefined) {

    } else {
      let array = [0];
      let n = parseFloat(stock) * 4;
      let n1 = 0;
      let n2 = 0;
      if (parseFloat(existencia) > parseFloat(n)) {
        n1 = parseFloat(existencia) / 10;
        for (let i = 0; i < 12; i++) {
          n2 = n2 + n1;
          array.push(parseFloat(n2.toFixed(2)));
        }
      } else {
        n1 = n / 10;
        for (let i = 0; i < 10; i++) {
          n2 = n2 + n1;
          array.push(parseFloat(n2.toFixed(2)));
        }
      }

      setFlujo(array);
    }
  };

  const onChange = (e) => {
    if (e.target.name === "codigo") {
      e.target.value = e.target.value.toUpperCase();
    } else if (
      e.target.name === "unidadP" ||
      e.target.name === "unidadA" ||
      e.target.name === "idunidadmedida"
    ) {
      if (cmbUniPrincipal.current.selectedIndex >= 0) {
        var unic = [];
        var univ = [];
        setUnidadC([]);
        setUnidadV([]);
        if (e.target.name === "idunidadmedida") {
          cmbUniPrincipal.current.selectedIndex =
            cmbUnidMedida.current.selectedIndex;
        } else {
          cmbUnidMedida.current.selectedIndex =
            cmbUniPrincipal.current.selectedIndex;
        }

        unic.push({
          idunidadmedida: cmbUniPrincipal.current.value,
          descripcion:
            cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text,
        });

        univ.push({
          idunidadmedida: cmbUniPrincipal.current.value,
          descripcion:
            cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text,
        });

        if (cmbUniAlterna.current.selectedIndex >= 0) {
          unic.push({
            idunidadmedida: cmbUniAlterna.current.value,
            descripcion:
              cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text,
          });

          univ.push({
            idunidadmedida: cmbUniAlterna.current.value,
            descripcion:
              cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text,
          });

          var uni = [];
          uni.push({
            iduni: "0",
            descripcion:
              cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                .text +
              "X" +
              cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text,
          });
          uni.push({
            iduni: "1",
            descripcion:
              cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text +
              "X" +
              cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                .text,
          });
          setFactor(uni);
          cmbUniFactor.current.selectedIndex = -1;
        }
        setUnidadC(unic);
        setUnidadV(univ);
        cmbUniVenta.current.selectedIndex = -1;
        cmbUniCompra.current.selectedIndex = -1;
      }
    } else if (e.target.name === "almacen") {
      if (e.target.value === "true") {
        setVisibleA("visible");
        txtStockMini.current.value = "0,00";
      } else {
        setVisibleA("hidden");
        txtStockMini.current.value = "0,00";
      }
    } else if (e.target.name === "unifactor") {
      calcularFactorConversion();
    } else if (e.target.name === "metodocosto") {
      setCostoSelect(e.target.value);
      calcularPrecioSinImpuestos();
    } else if (e.target.id === "chekvacio") {
      if (e.target.checked === true) {
        setValvacio(1);
        seleccionarClassVacios(2, "");
      } else {
        setValvacio(0);
        txtCodigoVacio.current.value = "";
      }
    }
  };

  const onChangeValidar = () => {
    var sigue = true;

    if (txtIdproducto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Id no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtIdproducto.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Introduzca la Descripción",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.focus();
    } else if (txtNombreCorto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Nombre Corto no deben estar Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtNombreCorto.current.focus();
    } else if (cmbTipoProd.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Tipo de Producto o Servicio no deben estar Vacio",
        icono: "informacion",
      });
      sigue = false;
      cmbTipoProd.current.focus();
    } else if (cmbFabricante.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Fabricante del Producto",
        icono: "informacion",
      });
      sigue = false;
      cmbFabricante.current.focus();
    } else if (cmbUnidMedida.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Unidad de Medida no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      cmbUnidMedida.current.focus();
    } else if (txtIvaCompra.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El % de Iva Para la Compra no deben estar Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtIvaCompra.current.focus();
    } else if (txtIvaVenta.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El % de Iva Para la Venta no deben estar Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtIvaVenta.current.focus();
    } else if (cmbPrecioVenta.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Tipo de precio de venta no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      cmbPrecioVenta.current.focus();
    } else if (
      cmbAlmacen.current.value === "true" &&
      txtStockMini.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Stock Minimo no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtStockMini.current.focus();
    } else if (
      cmbAlmacen.current.value === "true" &&
      txtStockMini.current.value.trim() === "0,00"
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Stock Minimo debe ser mayor a Cero(0)",
        icono: "informacion",
      });
      sigue = false;
      txtStockMini.current.focus();
    } else if (cmbMetodoCosto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Metodo de costo no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      cmbMetodoCosto.current.focus();
    } else if (txtCostoProveSinImp.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Costo del Proveedoor no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCostoProveSinImp.current.focus();
    } else if (txtCostoCalcuSinImp.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Costo Calculado no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCostoCalcuSinImp.current.focus();
    } else if (txtUltimoCostoSinImp.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Ùltimo Costo no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtUltimoCostoSinImp.current.focus();
    } else if (txtCostoPromeSinImp.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Costo Promedio no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCostoPromeSinImp.current.focus();
    } else if (txtUtilidadMaxi.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Utilidad del Precio Maximo no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtUtilidadMaxi.current.focus();
    } else if (txtUtilidadOfe.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Utilidad del Precio Oferta no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtUtilidadOfe.current.focus();
    } else if (txtUtilidadMayor.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Utilidad del Precio al Mayor no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtUtilidadMayor.current.focus();
    } else if (txtUtilidadMini.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Utilidad del Precio Minimo no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtUtilidadMini.current.focus();
    } else if (radioSi.current.checked) {
      if (cmbUniAlterna.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La Unidad de Medida Alterna no debe estar vacia",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        cmbUniAlterna.current.focus();
      } else if (cmbUniVenta.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La Unidad de Venta no debe estar vacia",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        cmbUniVenta.current.focus();
      } else if (cmbUniCompra.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La Unidad de Compra no debe estar vacia",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        cmbUniCompra.current.focus();
      } else if (
        txtFactor.current.value.trim() === "" ||
        txtFactor.current.value.trim() === "0.00"
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "El Factor de Conversion no deben estar Vacio ni ser cero(0,00)",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtFactor.current.focus();
      } else if (cmbUniFactor.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La Unidad del Factor de Conversion no debe estar vacia",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        cmbUniFactor.current.focus();
      } else if (
        txtCostoProveSinImpAlter.current.value === "0,00" ||
        txtCostoProveSinImpAlter.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "El Costo del Proveedoor de la Unidad Alterna no debe estar vacio ni ser cero (0,00)",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtCostoProveSinImpAlter.current.focus();
      } else if (txtCostoCalcuSinImpAlter.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El Costo Calculado de la Unidad Alterna no debe estar vacio",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtCostoCalcuSinImpAlter.current.focus();
      } else if (txtUltimoCostoSinImpAlter.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El Ùltimo Costo de la Unidad Alterna no debe estar vacio",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtUltimoCostoSinImpAlter.current.focus();
      } else if (txtCostoPromeSinImpAlter.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El Costo Promedio de la Unidad Alterna no debe estar vacio",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtCostoPromeSinImpAlter.current.focus();
      } else if (txtUtilidadMaxiAlter.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "La Utilidad del Precio Maximo de la Unidad Alterna no debe estar vacia",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtUtilidadMaxiAlter.current.focus();
      } else if (txtUtilidadOfeAlter.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "La Utilidad del Precio Oferta de la Unidad Alterna no debe estar vacia",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtUtilidadOfeAlter.current.focus();
      } else if (txtUtilidadMayorAlter.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "La Utilidad del Precio al Mayor de la Unidad Alterna no debe estar vacia",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtUtilidadMayorAlter.current.focus();
      } else if (txtUtilidadMiniAlter.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "La Utilidad del Precio Minimo de la Unidad Alterna no debe estar vacia",
          icono: "informacion",
        });
        sigue = false;
        setTabIndex({ tab1: "tab", tab2: "tab" });
        setACtiveTab({
          tab1: "nav-link text-light bg-blue-100 rounded",
          tab2: "nav-link active text-light bg-blue-200 rounded",
        });
        setTabValid({ tab1: "false", tab2: "true" });
        setTabPanel({
          tab1: "tab-pane fade",
          tab2: "tab-pane fade show active",
        });
        txtUtilidadMiniAlter.current.focus();
      }
    }

    let tasa = 0.0;
    if (monedaCambio.idmoneda === monedaSub.idmoneda) {
      tasa = 1.0;
    } else if (monedaCambio.idmoneda === moneda.idmoneda) {
      tasa = monedaSub.valormoneda;
    } else {
      tasa = round(monedaSub.valormoneda / monedaCambio.valormoneda);
    }
    const costoproveedor =
      parseFloat(
        txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", ".")
      ) / tasa;
    const costocalculado =
      parseFloat(
        txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", ".")
      ) / tasa;
    const ultimocosto =
      parseFloat(
        txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", ".")
      ) / tasa;
    const costopromedio =
      parseFloat(
        txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", ".")
      ) / tasa;
    const utipreciomaxi = parseFloat(
      txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")
    );
    const utiprecioofe = parseFloat(
      txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")
    );
    const utipreciomayor = parseFloat(
      txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")
    );
    const utipreciomini = parseFloat(
      txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")
    );
    const preciomaxi =
      parseFloat(
        txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", ".")
      ) / tasa;
    const precioofe =
      parseFloat(
        txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", ".")
      ) / tasa;
    const preciomayor =
      parseFloat(
        txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", ".")
      ) / tasa;
    const preciomini =
      parseFloat(
        txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", ".")
      ) / tasa;

    /* unidad alterna */
    const costoproveedoralter = radioSi.current.checked
      ? parseFloat(
        txtCostoProveSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      ) / tasa
      : "0.00";
    const costocalculadoalter = radioSi.current.checked
      ? parseFloat(
        txtCostoCalcuSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      ) / tasa
      : "0.00";
    const ultimocostoalter = radioSi.current.checked
      ? parseFloat(
        txtUltimoCostoSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      ) / tasa
      : "0.00";
    const costopromedioalter = radioSi.current.checked
      ? parseFloat(
        txtCostoPromeSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      ) / tasa
      : "0.00";
    const utipreciomaxialter = radioSi.current.checked
      ? parseFloat(
        txtUtilidadMaxiAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      )
      : "0.00";
    const utiprecioofealter = radioSi.current.checked
      ? parseFloat(
        txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")
      )
      : "0.00";
    const utipreciomayoralter = radioSi.current.checked
      ? parseFloat(
        txtUtilidadMayorAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      )
      : "0.00";
    const utipreciominialter = radioSi.current.checked
      ? parseFloat(
        txtUtilidadMiniAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      )
      : "0.00";

    ///precio venta alterna
    const preciomaxialter = radioSi.current.checked
      ? parseFloat(
        txtPrecioMaxiSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      ) / tasa
      : "0.00";
    const precioofealter = radioSi.current.checked
      ? parseFloat(
        txtPrecioOfeSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      ) / tasa
      : "0.00";
    const preciomayoralter = radioSi.current.checked
      ? parseFloat(
        txtPrecioMayorSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      ) / tasa
      : "0.00";
    const preciominialter = radioSi.current.checked
      ? parseFloat(
        txtPrecioMiniSinImpAlter.current.value
          .replace(/\./g, "")
          .replace(",", ".")
      ) / tasa
      : "0.00";

    if (sigue) {
      var prod = [];
      prod.push({
        idproducto: txtIdproductoHidden.current.value,
        codigo: txtIdproducto.current.value.toUpperCase(),
        nombre: txtNombre.current.value.toUpperCase(),
        servicio: chkServicio.current.checked,
        nombrecorto: txtNombreCorto.current.value.toUpperCase(),
        idtipoproducto: cmbTipoProd.current.value,
        marca: cmbMarca.current.value === "" ? 0 : cmbMarca.current.value,
        modelo: cmbModelo.current.value === "" ? 0 : cmbModelo.current.value,
        referencia: txtReferencia.current.value.toUpperCase(),
        diasgarantia:
          txtDiasGar.current.value === "" ? null : txtDiasGar.current.value,
        idunidadmedida: cmbUnidMedida.current.value,
        idmoneda: monedaSub.idmoneda,
        ivacompra: parseFloat(
          txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")
        ),
        ivaventa: parseFloat(
          txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")
        ),
        exento:
          parseFloat(
            txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")
          ) > 0.0
            ? false
            : true,
        tipoprecio: cmbPrecioVenta.current.value,
        almacen: (cmbAlmacen.current.value = "true" ? true : false),
        stockminimo: parseFloat(
          txtStockMini.current.value.replace(/\./g, "").replace(",", ".")
        ),
        metodocosto: cmbMetodoCosto.current.value,
        costoproveedor: costoproveedor,
        costocalculado: costocalculado,
        ultimocosto: ultimocosto,
        costopromedio: costopromedio,
        utipreciomaxi: utipreciomaxi,
        utiprecioofe: utiprecioofe,
        utipreciomayor: utipreciomayor,
        utipreciomini: utipreciomini,
        preciomaxi: preciomaxi,
        precioofe: precioofe,
        preciomayor: preciomayor,
        preciomini: preciomini,

        idunidadalterna: radioSi.current.checked
          ? cmbUniAlterna.current.value
          : "0",
        idunidadcompra: radioSi.current.checked
          ? cmbUniCompra.current.value
          : "0",
        idunidadventa: radioSi.current.checked
          ? cmbUniVenta.current.value
          : "0",
        valorfactor: radioSi.current.checked
          ? parseFloat(
            txtFactor.current.value.replace(/\./g, "").replace(",", ".")
          )
          : "0.00",
        tipofactor: radioSi.current.checked ? cmbUniFactor.current.value : "",
        costoproveedoralter: costoproveedoralter,
        costocalculadoalter: costocalculadoalter,
        ultimocostoalter: ultimocostoalter,
        costopromedioalter: costopromedioalter,
        utipreciomaxialter: utipreciomaxialter,
        utiprecioofealter: utiprecioofealter,
        utipreciomayoralter: utipreciomayoralter,
        utipreciominialter: utipreciominialter,
        preciomaxialter: preciomaxialter,
        precioofealter: precioofealter,
        preciomayoralter: preciomayoralter,
        preciominialter: preciominialter,
        idtipoingreso: "0",
        idfabricante: cmbFabricante.current.value,
        vacio: txtVacio.current.checked,
        idclasevacio: valvacio === 1 ? txtCodigoVacio.current.value : null,
      });

      setProducto({
        codigo: txtIdproducto.current.value.toUpperCase(),
        idproducto: txtIdproductoHidden.current.value,
        ivaventa: parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")),
        nombre: txtNombre.current.value.toUpperCase(),
        nombrecorto: txtNombreCorto.current.value.toUpperCase(),
        preciomax: preciomaxi,
        unidadalterna: radioSi.current.checked
          ? cmbUniAlterna.current.value
          : "0",
        unidadmedida: cmbUnidMedida.current.value
      });

      let upload = new FormData();

      upload.append("producto", JSON.stringify(prod));
      upload.append("codigo", txtIdproducto.current.value.toUpperCase());
      upload.append("imagenactual", imagen.imagenactual);
      upload.append("imagennueva", imagen.imagen);

      setBody(upload);
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const tabs = (vl) => (e) => {
    e.preventDefault();

    if (vl === 2 && tabIndex.tab2 !== "") {
      setACtiveTab({
        tab1: "nav-link text-light bg-blue-100 rounded",
        tab2: "nav-link active text-light bg-blue-200 rounded",
      });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
    } else {
      setACtiveTab({
        tab1: "nav-link active text-light bg-blue-100 rounded",
        tab2: "nav-link text-light bg-blue-200 rounded",
      });
      setTabValid({ tab1: "true", tab2: "false" });
      setTabPanel({
        tab1: "tab-pane fade show active",
        tab2: "tab-pane fade ",
      });
    }
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    const cambio = onCambioMoneda({
      moneda: combomoneda[i],
      productos: [],
      monedaPre: moneda,
      monedaSub: monedaSub,
    });
    setMonedaCambio(cambio.monedacambio);
    txtNombre.current.focus();
  };

  const seleccionarExistencia = (id, stock) => {
    let campos = "cantidad";
    let nomtab = "existencia";
    let nomid = "idproducto";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let cantidad = "";

          if (response.data === "") {
            cantidad = 0;
          } else {
            cantidad = response.data.cantidad;
          }
          manesillas(stock, cantidad);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = (idp) => {
    let campos = "*";
    let nomtab = "producto";
    let nomid = "codigo";
    let id = idp.toUpperCase();
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (
              response.data.imagen.trim() !== "subir.png" &&
              response.data.imagen.trim() !== null &&
              response.data.imagen.trim() !== ""
            ) {
              setImagen({
                ...imagen,
                imagenactual: response.data.imagen.trim(),
              });
              setPathImage({
                imagen: `${op.conexion
                  }/imagen?img=${organizacion}/productos/${response.data.imagen.trim()}`,
              });
            }

            if (response.data.vacio !== false) {
              setValvacio(1);
              seleccionarClassVacios(1, response.data.idclasevacio);
            } else {
              setValvacio(0);
            }

            txtIdproductoHidden.current.value = response.data.idproducto;
            chkServicio.current.checked = response.data.servicio;
            txtIdproducto.current.value = response.data.codigo.trim();
            txtNombre.current.value = response.data.nombre.trim();
            txtReferencia.current.value = response.data.referencia;
            txtNombreCorto.current.value = response.data.nombrecorto.trim();
            cmbTipoProd.current.value = response.data.idtipoproducto;
            cmbFabricante.current.value = response.data.idfabricante;
            txtVacio.current.checked = response.data.vacio;
            txtDiasGar.current.value = response.data.diasgarantia;
            cmbMarca.current.value = response.data.marca;
            cmbModelo.current.value = response.data.modelo;
            // cmbMoneda.current.value = response.data.idmoneda;
            cmbUnidMedida.current.value = response.data.idunidadmedida;

            txtIvaCompra.current.value = formatMoneda(
              response.data.ivacompra
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtIvaVenta.current.value = formatMoneda(
              response.data.ivaventa
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            //chkExento.current.checked = response.data.exento;
            cmbPrecioVenta.current.value = response.data.tipoprecio;
            cmbMetodoCosto.current.value = response.data.metodocosto;
            setCostoSelect(response.data.metodocosto);
            setPrecioSelect(response.data.tipoprecio);
            //chkAlmacen.current.checked = response.data.almacen;
            cmbAlmacen.current.value = response.data.almacen ? "true" : "false";
            txtStockMini.current.value =
              response.data.stockminimo === null
                ? "0,00"
                : formatMoneda(
                  response.data.stockminimo
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                );

            let IvaCompra = response.data.ivacompra / 100;
            let IvaVenta = response.data.ivaventa / 100;

            txtCostoProveSinImp.current.value = formatMoneda(
              response.data.costoproveedor
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtCostoCalcuSinImp.current.value = formatMoneda(
              response.data.costocalculado
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtUltimoCostoSinImp.current.value = formatMoneda(
              response.data.ultimocosto
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtCostoPromeSinImp.current.value = formatMoneda(
              response.data.costopromedio
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );

            txtCostoProveConImp.current.value = formatMoneda(
              ((1 + IvaCompra) * response.data.costoproveedor)
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtCostoCalcuConImp.current.value = formatMoneda(
              ((1 + IvaCompra) * response.data.costocalculado)
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtUltimoCostoConImp.current.value = formatMoneda(
              ((1 + IvaCompra) * response.data.ultimocosto)
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtCostoPromeConImp.current.value = formatMoneda(
              ((1 + IvaCompra) * response.data.costopromedio)
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );

            txtPrecioMaxiSinImp.current.value = formatearMonto(
              response.data.preciomaxi,
              3
            );
            txtPrecioOfeSinImp.current.value = formatearMonto(
              response.data.precioofe,
              3
            );
            txtPrecioMayorSinImp.current.value = formatearMonto(
              response.data.preciomayor,
              3
            );
            txtPrecioMiniSinImp.current.value = formatearMonto(
              response.data.preciomini,
              3
            );

            txtUtilidadMaxi.current.value = formatMoneda(
              response.data.utipreciomaxi
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtUtilidadOfe.current.value = formatMoneda(
              response.data.utiprecioofe
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtUtilidadMayor.current.value = formatMoneda(
              response.data.utipreciomayor
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtUtilidadMini.current.value = formatMoneda(
              response.data.utipreciomini
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );

            let costo = 0.0;

            if (parseInt(response.data.metodocosto) === 1) {
              costo = (1 + IvaCompra) * response.data.costoproveedor * IvaVenta;
            }
            if (parseInt(response.data.metodocosto) === 2) {
              costo = (1 + IvaCompra) * response.data.costocalculado * IvaVenta;
            }
            if (parseInt(response.data.metodocosto) === 3) {
              costo = (1 + IvaCompra) * response.data.ultimocosto * IvaVenta;
            }
            if (parseInt(response.data.metodocosto) === 4) {
              costo = (1 + IvaCompra) * response.data.costopromedio * IvaVenta;
            }

            /*             if (costo > monto) {
              setAlerta({ ...alerta, maxalt: 1 });
            } else {
              setAlerta({ ...alerta, maxalt: 0 });
            }
 */
            txtPrecioMaxiConImp.current.value = formatMoneda(
              ((1 + IvaVenta) * parseFloat(response.data.preciomaxi))
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtPrecioOfeConImp.current.value = formatMoneda(
              ((1 + IvaVenta) * parseFloat(response.data.precioofe))
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtPrecioMayorConImp.current.value = formatMoneda(
              ((1 + IvaVenta) * parseFloat(response.data.preciomayor))
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtPrecioMiniConImp.current.value = formatMoneda(
              ((1 + IvaVenta) * parseFloat(response.data.preciomini))
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );

            seleccionarExistencia(
              response.data.idproducto,
              response.data.stockminimo
            );
            //seleccionarSimboloId(response.data.idmoneda);
            if (response.data.idunidadalterna > 0) {
              radioSi.current.checked = true;
              radioNo.current.checked = false;
              setTabIndex({ tab1: "tab", tab2: "tab" });
              if (operacion === 2) {
                setHabilitadoAlter(false);
              }
              cmbUniPrincipal.current.value = response.data.idunidadmedida;
              cmbUniAlterna.current.value = response.data.idunidadalterna;
              txtFactor.current.value = formatMoneda(
                response.data.valorfactor
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              var uni = [];
              uni.push({
                iduni: "0",
                descripcion:
                  cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                    .text +
                  "X" +
                  cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex]
                    .text,
              });
              uni.push({
                iduni: "1",
                descripcion:
                  cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex]
                    .text +
                  "X" +
                  cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                    .text,
              });
              setFactor(uni);
              /*for (let i = 0; i < uni.length; i++) {
                            if (uni[i].descripcion === response.data.tipofactor) {
                                cmbUniFactor.current.value = uni[i].iduni;
                                break;
                            }
                        }*/
              cmbUniFactor.current.value = response.data.tipofactor;
              var unic = [];
              var univ = [];
              setUnidadC([]);
              setUnidadV([]);

              unic.push({
                idunidadmedida: cmbUniPrincipal.current.value,
                descripcion:
                  cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                    .text,
              });

              univ.push({
                idunidadmedida: cmbUniPrincipal.current.value,
                descripcion:
                  cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex]
                    .text,
              });

              unic.push({
                idunidadmedida: cmbUniAlterna.current.value,
                descripcion:
                  cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex]
                    .text,
              });
              univ.push({
                idunidadmedida: cmbUniAlterna.current.value,
                descripcion:
                  cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex]
                    .text,
              });
              setUnidadC(unic);
              setUnidadV(univ);

              cmbUniCompra.current.value = response.data.idunidadcompra;
              cmbUniVenta.current.value = response.data.idunidadventa;
              /////////////////////////////////////////

              txtCostoProveSinImpAlter.current.value = formatMoneda(
                response.data.costoproveedoralter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtCostoCalcuSinImpAlter.current.value = formatMoneda(
                response.data.costocalculadoalter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtUltimoCostoSinImpAlter.current.value = formatMoneda(
                response.data.ultimocostoalter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtCostoPromeSinImpAlter.current.value = formatMoneda(
                response.data.costopromedioalter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );

              txtCostoProveConImpAlter.current.value = formatMoneda(
                ((1 + IvaCompra) * response.data.costoproveedoralter)
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtCostoCalcuConImpAlter.current.value = formatMoneda(
                ((1 + IvaCompra) * response.data.costocalculadoalter)
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtUltimoCostoConImpAlter.current.value = formatMoneda(
                ((1 + IvaCompra) * response.data.ultimocostoalter)
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtCostoPromeConImpAlter.current.value = formatMoneda(
                ((1 + IvaCompra) * response.data.costopromedioalter)
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );

              txtPrecioMaxiSinImpAlter.current.value = formatMoneda(
                response.data.preciomaxialter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtPrecioOfeSinImpAlter.current.value = formatMoneda(
                response.data.precioofealter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtPrecioMayorSinImpAlter.current.value = formatMoneda(
                response.data.preciomayoralter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtPrecioMiniSinImpAlter.current.value = formatMoneda(
                response.data.preciominialter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );

              txtUtilidadMaxiAlter.current.value = formatMoneda(
                response.data.utipreciomaxialter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtUtilidadOfeAlter.current.value = formatMoneda(
                response.data.utiprecioofealter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtUtilidadMayorAlter.current.value = formatMoneda(
                response.data.utipreciomayoralter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtUtilidadMiniAlter.current.value = formatMoneda(
                response.data.utipreciominialter
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );

              let costo = 0.0;

              if (parseInt(response.data.metodocosto) === 1) {
                costo =
                  (1 + IvaCompra) *
                  response.data.costoproveedoralter *
                  IvaVenta;
              }
              if (parseInt(response.data.metodocosto) === 2) {
                costo =
                  (1 + IvaCompra) *
                  response.data.costocalculadoalter *
                  IvaVenta;
              }
              if (parseInt(response.data.metodocosto) === 3) {
                costo =
                  (1 + IvaCompra) * response.data.ultimocostoalter * IvaVenta;
              }
              if (parseInt(response.data.metodocosto) === 3) {
                costo =
                  (1 + IvaCompra) * response.data.costopromedioalter * IvaVenta;
              }

              txtPrecioMaxiConImpAlter.current.value = formatMoneda(
                ((1 + IvaVenta) * parseFloat(response.data.preciomaxialter))
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtPrecioOfeConImpAlter.current.value = formatMoneda(
                ((1 + IvaVenta) * parseFloat(response.data.precioofealter))
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtPrecioMayorConImpAlter.current.value = formatMoneda(
                ((1 + IvaVenta) * parseFloat(response.data.preciomayoralter))
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
              txtPrecioMiniConImpAlter.current.value = formatMoneda(
                ((1 + IvaVenta) * parseFloat(response.data.preciominialter))
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );

              txtPrecioMaxiSinImp.current.style.color =
                parseFloat(response.data.utipreciomaxi) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioOfeSinImp.current.style.color =
                parseFloat(response.data.utiprecioofe) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioMayorSinImp.current.style.color =
                parseFloat(response.data.utipreciomayor) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioMiniSinImp.current.style.color =
                parseFloat(response.data.utipreciomini) < 0.0
                  ? "#FB0000"
                  : "#000000";

              txtPrecioMaxiSinImpAlter.current.style.color =
                parseFloat(response.data.utipreciomaxialter) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioOfeSinImpAlter.current.style.color =
                parseFloat(response.data.utiprecioofealter) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioMayorSinImpAlter.current.style.color =
                parseFloat(response.data.utipreciomayoralter) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioMiniSinImpAlter.current.style.color =
                parseFloat(response.data.utipreciominialter) < 0.0
                  ? "#FB0000"
                  : "#000000";
            } else {
              txtPrecioMaxiSinImp.current.style.color =
                parseFloat(response.data.utipreciomaxi) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioOfeSinImp.current.style.color =
                parseFloat(response.data.utiprecioofe) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioMayorSinImp.current.style.color =
                parseFloat(response.data.utipreciomayor) < 0.0
                  ? "#FB0000"
                  : "#000000";
              txtPrecioMiniSinImp.current.style.color =
                parseFloat(response.data.utipreciomini) < 0.0
                  ? "#FB0000"
                  : "#000000";

              radioSi.current.checked = false;
              radioNo.current.checked = true;
              setTabIndex({ tab1: "tab", tab2: "" });
              setHabilitadoAlter(false);
              blanquearAlter();
            }

            if (response.data.almacen) {
              setVisibleA("visible");
            }

            if (operacion === 2) {
              setHabilitado(false);
              // txtCodigo.current.focus();
            } else {
              btnAceptar.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Producto no existe.",
              icono: "informacion",
            });
            txtIdproducto.current.value = "";
            txtIdproducto.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/producto/actualizar/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          blanquear();
          blanquearAlter();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = error;
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const imprimirAlmacen = () => {
    if (accbtnproducto && accbtnproducto.toString().substring(4, 5) === "1") {
      window.open(
        `${op.reportes}/productos?afiliado=${organizacion}&reporte=ListaProducto`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    props.onHideAceptaProduct(producto);
    props.onHideCancela();
  }

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.ope === 2) {
          seleccionarMonedas();
          setVisibleBtn("hidden");
          setOperacion(props.ope);
          setHabilitado(false);
          setHabilitadoAlter(false);
        }

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Modificar Producto</h3></div>

        <a href='#' onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className="row col-md-12 px-0" style={{ margin: 0 }}>
          <div className="tipo-letra row mx-auto col-lg-12 mx-auto mt-2 px-0">
            <ul className="nav mb-1" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className={activeTab.tab1}
                  id="ex-with-icons-tab-1"
                  onClick={tabs(1)}
                  data-mdb-toggle={tabIndex.tab1}
                  href="#tab1"
                  role="tab"
                  aria-controls="tab1"
                  aria-selected={tabvalid.tab1}
                >
                  <i className="fas fa-chart-pie fa-fw me-2" />
                  Información
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className={activeTab.tab2}
                  id="ex-with-icons-tab-2"
                  onClick={tabs(2)}
                  data-mdb-toggle={tabIndex.tab2}
                  href="#tab2"
                  role="tab"
                  aria-controls="tabs2"
                  aria-selected={tabvalid.tab1}
                >
                  <i className="fas fa-highlighter fa-fw me-2" />
                  Unidad Alterna
                </a>
              </li>
              <li className="nav-item py-1 px-2">
                <button
                  type="button"
                  className="btn btn-sm btn-info rounded-pill"
                  onClick={imprimirAlmacen}
                >
                  <i className="fas fa-print"> Productos</i>
                </button>
              </li>
            </ul>
            <div
              className="tab-content"
              id="ex-with-icons-content"
              style={{ fontFamily: "Times New Roman, Times, serif" }}
            >
              <div
                className={tabPanel.tab1}
                id="ex-with-icons-tabs-1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div
                  className="col-md-12 row mx-auto bg-light rounded shadow"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <div className="col-md-12 mx-auto row">
                    <div className="input-group input-group-sm mb-2 col-12">
                      <input
                        type="hidden"
                        ref={txtIdproductoHidden}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="input-group input-group-sm mb-2 col-xl-3 col-lg-3 col-md-3 col-sm-3">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        CODIGO:
                      </label>
                      <input
                        type="text"
                        disabled
                        autoComplete="off"
                        ref={txtIdproducto}
                        onChange={onChange}
                        name="codigo"
                        className="form-control uppercase fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="col"></div>

                    <div className="input-group input-group-sm mb-2 col-pd-260">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        MONEDA:
                      </label>
                      <select
                        disabled={habilitado}
                        ref={cmbMoneda}
                        onChange={onChangeMoneda}
                        className="form-select form-select-sm fw-bold"
                        aria-label=".form-select-sm example"
                      >
                        {combomoneda &&
                          combomoneda.map((item, index) => (
                            <option key={index} value={index}>
                              {" "}
                              {`${item.descripcion} ${item.simbolo
                                } ${formatMoneda(
                                  item.valormoneda
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}`}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <div className="form-check" style={{ float: "right" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          disabled={habilitado}
                          ref={chkServicio}
                          value=""
                          id="flexCheckServicio"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckServicio"
                        >
                          Es un Servicio?
                        </label>
                      </div>
                    </div>
                    <div className="input-group input-group-sm mb-2 col-xl-9 col-lg-8 col-md-8 col-sm-8">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        NOMBRE:
                      </label>
                      <input
                        type="text"
                        ref={txtNombre}
                        autoComplete="off"
                        disabled={habilitado}
                        className="form-control text-uppercase fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputNombre"
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                    <div className="input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-5 col-sm-5">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        REFERENCIA:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        ref={txtReferencia}
                        disabled={habilitado}
                        className="form-control text-uppercase fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputRefe"
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                    <div className="input-group input-group-sm mb-2 col-xl-9 col-lg-8 col-md-7 col-sm-7">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        NOMBRE CORTO:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        ref={txtNombreCorto}
                        disabled={habilitado}
                        className="form-control text-uppercase fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputNombreCorto"
                        onKeyUp={handleInputChange}
                        onBlur={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-12 mx-auto mb-1">
                    <fieldset className=" row col-sm-12 mx-auto border-azul rounded justify-content-between">
                      <legend
                        className="float-none w-auto fw-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Configuración
                      </legend>
                      <div className="input-group input-group-sm mb-2 col-xl-6 col-lg-8 col-md-8 col-sm-12">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          TIPO PRODUCTO/SERVICIO:
                        </label>
                        <select
                          disabled={habilitado}
                          ref={cmbTipoProd}
                          className="form-select form-select-sm "
                          aria-label=".form-select-sm example"
                        >
                          {tipoP &&
                            tipoP.map((tipo) => (
                              <option
                                key={tipo.idtipoproducto}
                                value={tipo.idtipoproducto}
                              >
                                {" "}
                                {tipo.descripcion}
                              </option>
                            ))}
                        </select>
                        <button
                          disabled={habilitado}
                          onClick={abrirModal("tipop")}
                          className="btn btn-sm btn-primary rounded-circle mx-1"
                        >
                          <i className="fas fa-plus"></i>{" "}
                        </button>
                      </div>

                      <div className="input-group input-group-sm mb-2 col-xl-6 col-lg-8 col-md-8 col-sm-12">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          FABRICANTE:
                        </label>
                        <select
                          disabled={habilitado}
                          ref={cmbFabricante}
                          className="form-select form-select-sm "
                          aria-label=".form-select-sm example"
                        >
                          {fabri &&
                            fabri.map((tipo) => (
                              <option
                                key={tipo.idfabricante}
                                value={tipo.idfabricante}
                              >
                                {" "}
                                {tipo.descripcion}
                              </option>
                            ))}
                        </select>
                        <button
                          disabled={habilitado}
                          onClick={abrirModal("fabricante")}
                          className="btn btn-sm btn-primary rounded-circle mx-1"
                        >
                          <i className="fas fa-plus"></i>{" "}
                        </button>
                      </div>

                      <div className="input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          MARCA:
                        </label>
                        <select
                          disabled={habilitado}
                          ref={cmbMarca}
                          className="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                        >
                          <option value="0">--seleccione--</option>
                          {marca &&
                            marca.map((mark) => (
                              <option key={mark.idmarca} value={mark.idmarca}>
                                {" "}
                                {mark.descripcion}
                              </option>
                            ))}
                        </select>
                        <button
                          disabled={habilitado}
                          onClick={abrirModal("marca")}
                          className="btn btn-sm btn-primary rounded-circle mx-1"
                        >
                          <i className="fas fa-plus"></i>{" "}
                        </button>
                      </div>
                      <div className="input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          MODELO:
                        </label>
                        <select
                          disabled={habilitado}
                          ref={cmbModelo}
                          className="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                        >
                          <option value="0">--seleccione--</option>
                          {modelo &&
                            modelo.map((mod) => (
                              <option key={mod.idmodelo} value={mod.idmodelo}>
                                {" "}
                                {mod.descripcion}
                              </option>
                            ))}
                        </select>
                        <button
                          disabled={habilitado}
                          onClick={abrirModal("modelo")}
                          className="btn btn-sm btn-primary rounded-circle mx-1"
                        >
                          <i className="fas fa-plus"></i>{" "}
                        </button>
                      </div>
                      <div className="input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          UNID. MEDIDA:
                        </label>
                        <select
                          disabled={habilitado}
                          ref={cmbUnidMedida}
                          onChange={onChange}
                          name="idunidadmedida"
                          id="idunidadmedida"
                          className="form-select form-select-sm "
                          aria-label=".form-select-sm example"
                        >
                          <option value="">--seleccione--</option>
                          {unidadM &&
                            unidadM.map((unimedi) => (
                              <option
                                key={unimedi.idunidadmedida}
                                value={unimedi.idunidadmedida}
                              >
                                {" "}
                                {unimedi.descripcion}
                              </option>
                            ))}
                        </select>
                        <button
                          disabled={habilitado}
                          onClick={abrirModal("medida")}
                          className="btn btn-sm btn-primary rounded-circle mx-1"
                        >
                          <i className="fas fa-plus"></i>{" "}
                        </button>
                      </div>
                      <div className="input-group input-group-sm mb-2 col-pd-210 px-1">
                        <label
                          className="input-group-text text-right"
                          id="inputGroup-sizing-sm"
                        >
                          % IVA COMPRA:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={habilitado}
                          ref={txtIvaCompra}
                          className="form-control form-control-sm text-right fs-6"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="ivaCompra"
                          onFocus={seleccionarCampo}
                          onKeyUp={handleInputMontoChange}
                          onBlur={handleInputMontoChange}
                        />
                      </div>
                      <div className="input-group input-group-sm mb-2 col-pd-210 px-2">
                        <label
                          className="input-group-text text-right"
                          id="inputGroup-sizing-sm"
                        >
                          % IVA VENTA:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={habilitado}
                          ref={txtIvaVenta}
                          className="form-control form-control-sm text-right fs-6"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="ivaVenta"
                          onFocus={seleccionarCampo}
                          onKeyUp={handleInputMontoChange}
                          onBlur={handleInputMontoChange}
                        />
                      </div>
                      {/*                         <div className="col-pd-150 px-2">
                          <div className="form-check">
                            <input
                              disabled={habilitado}
                              ref={chkExento}
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label
                              className="form-check-label py-1"
                              htmlFor="flexCheckDefault"
                            >
                              EXENTO IVA
                            </label>
                          </div>
                        </div> */}

                      <div className="input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-4 col-sm-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          DIAS GARANTIA:
                        </label>
                        <input
                          type="number"
                          disabled={habilitado}
                          ref={txtDiasGar}
                          className="form-control fs-6"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="inputDiasGar"
                          onKeyUp={handleInputChange}
                          onBlur={handleInputChange}
                        />
                      </div>
                      <div className="input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          DESTINO:
                        </label>
                        <select
                          disabled={habilitado}
                          ref={cmbAlmacen}
                          name="almacen"
                          onChange={onChange}
                          className="form-select form-select-sm "
                          aria-label=".form-select-sm example"
                        >
                          <option value="true">ALMACEN</option>
                          <option value="false">USO INTERNO</option>
                        </select>
                      </div>
                      {/*                         <div className="col-pd-160">
                          <div className="form-check">
                            <input
                              disabled={habilitado}
                              ref={chkAlmacen}
                              className="form-check-input"
                              type="checkbox"
                              defaultChecked
                              value=""
                              name="almacen"
                              onChange={onChange}
                            />
                            <label
                              className="form-check-label py-1"
                              htmlFor="flexCheckDefault"
                            >
                              ALMACEN
                            </label>
                          </div>
                        </div> */}
                      <div
                        className="input-group input-group-sm mb-2 col-pd-230"
                        style={{ visibility: visibleA }}
                      >
                        <label
                          className="input-group-text text-right"
                          id="inputGroup-sizing-sm"
                        >
                          STOCK MINIMO:
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          disabled={true}
                          ref={txtStockMini}
                          className="form-control form-control-sm text-right fs-6"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          id="stockminimo"
                          defaultValue="0,00"
                          onFocus={seleccionarCampo}
                          onKeyUp={handleInputMontoChange}
                          onBlur={handleInputMontoChange}
                        />
                      </div>

                      <div className="col-pd-230">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            disabled={habilitado}
                            ref={txtVacio}
                            onChange={onChange}
                            value=""
                            id="chekvacio"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="chekvacio"
                          >
                            Vacio?
                          </label>
                        </div>
                      </div>

                      {valvacio === 1 ? (
                        <div className="input-group input-group-sm mb-2 col-pd-350 px-2">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            TIPO VACIO:
                          </label>
                          <select
                            disabled={habilitado}
                            ref={txtCodigoVacio}
                            onChange={onChange}
                            name="idclasevacio"
                            id="idclasevacio"
                            className="form-select form-select-sm "
                            aria-label=".form-select-sm example"
                          >
                            <option value="">--seleccione--</option>
                            {classvacios &&
                              classvacios.map((unimedi) => (
                                <option
                                  key={unimedi.idclasevacio}
                                  value={unimedi.idclasevacio}
                                >
                                  {" "}
                                  {unimedi.descripcion}
                                </option>
                              ))}
                          </select>
                          <button
                            disabled={habilitado}
                            onClick={abrirModal("classvacios")}
                            className="btn btn-sm btn-primary rounded-circle mx-1"
                          >
                            <i className="fas fa-plus"></i>{" "}
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                    </fieldset>
                  </div>

                  <div
                    className="col-md-12 mx-auto row mb-1"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <div className="col-xl-6 px-0">
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between pb-0">
                        <div className="input-group input-group-sm mb-2 col-sm-12 px-2">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            METODO DE COSTO:
                          </label>
                          <select
                            disabled={habilitado}
                            ref={cmbMetodoCosto}
                            className="form-select form-select-sm bg-info"
                            aria-label=".form-select-sm example"
                            name="metodocosto"
                            onChange={onChange}
                            defaultValue={1}
                          >
                            <option value="1">COSTO PROVEEDOR</option>
                            <option value="2">COSTO CALCULADO</option>
                            <option value="3">ULTIMO COSTO</option>
                            <option value="4">COSTO PROMEDIO</option>
                          </select>
                        </div>

                        <table className="table table-sm col-md-12 border bg-light">
                          <thead className="azulGradiant text-light fw-bold">
                            <tr>
                              <th className="text-center" scope="col">
                                <label style={{ fontSize: "11px" }}>
                                  COSTOS
                                </label>
                              </th>
                              <th className="text-center" scope="col">
                                <label style={{ fontSize: "11px" }}>
                                  SIN IMPUESTO
                                </label>
                              </th>
                              <th
                                className="text-center border-right border-light"
                                scope="col"
                              >
                                <label style={{ fontSize: "11px" }}>
                                  CON IMPUESTO
                                </label>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="text-center border-left">
                                {costoSelect === "1" && (
                                  <i className="fas fa-arrow-right text-danger"></i>
                                )}{" "}
                                Costo Proveedor: <b>{monedaCambio.simbolo}</b>
                              </td>
                              <td style={{ width: "30%" }}>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  ref={txtCostoProveSinImp}
                                  className="form-control form-control-sm text-right fs-6"
                                  id="costoProveSinImpu"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                ></input>
                              </td>
                              <td
                                className="border-right"
                                style={{ width: "30%" }}
                              >
                                <input
                                  type="text"
                                  disabled
                                  ref={txtCostoProveConImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-center border-left">
                                {costoSelect === "2" && (
                                  <i className="fas fa-arrow-right text-danger"></i>
                                )}{" "}
                                Costo Calculado: <b>{monedaCambio.simbolo}</b>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  ref={txtCostoCalcuSinImp}
                                  className="form-control form-control-sm text-right fs-6"
                                  id="costoCalcuSinImpu"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                ></input>
                              </td>
                              <td className="border-right">
                                <input
                                  type="text"
                                  disabled
                                  ref={txtCostoCalcuConImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-center border-left">
                                {costoSelect === "3" && (
                                  <i className="fas fa-arrow-right text-danger"></i>
                                )}{" "}
                                Ultimo Costo: <b>{monedaCambio.simbolo}</b>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  ref={txtUltimoCostoSinImp}
                                  className="form-control form-control-sm text-right fs-6"
                                  id="costoUltiSinImpu"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                ></input>
                              </td>
                              <td className="border-right">
                                <input
                                  type="text"
                                  disabled
                                  ref={txtUltimoCostoConImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-center border-left">
                                {costoSelect === "4" && (
                                  <i className="fas fa-arrow-right text-danger"></i>
                                )}{" "}
                                Costo Promedio: <b>{monedaCambio.simbolo}</b>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  ref={txtCostoPromeSinImp}
                                  className="form-control form-control-sm text-right fs-6"
                                  id="costoPromeSinImpu"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                ></input>
                              </td>
                              <td className="border-right">
                                <input
                                  type="text"
                                  disabled
                                  ref={txtCostoPromeConImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </fieldset>
                    </div>

                    <div className="col-xl-6 px-0">
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between pb-0">
                        <div className="input-group input-group-sm mb-2 col-sm-12 px-2">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            PRECIO VENTA:
                          </label>
                          <select
                            disabled={habilitado}
                            ref={cmbPrecioVenta}
                            onChange={(e) => setPrecioSelect(e.target.value)}
                            className="form-select form-select-sm bg-success"
                            aria-label=".form-select-sm example"
                            defaultValue="1"
                          >
                            <option value="1">MAXIMO</option>
                            <option value="2">OFERTA</option>
                            <option value="3">MAYOR</option>
                            <option value="4">MINIMO</option>
                          </select>
                        </div>

                        <table className="table table-sm col-md-12 border bg-light">
                          <thead className="azulGradiant text-light fw-bold">
                            <tr>
                              <th className="text-center" scope="col">
                                <label style={{ fontSize: "11px" }}>
                                  PRECIOS
                                </label>
                              </th>
                              <th className="text-center " scope="col">
                                <label style={{ fontSize: "11px" }}>
                                  SIN IMPUESTO
                                </label>
                              </th>
                              <th className="text-center" scope="col">
                                <label style={{ fontSize: "11px" }}>
                                  UTILIDAD %
                                </label>
                              </th>
                              <th className="text-center" scope="col">
                                <label style={{ fontSize: "11px" }}>
                                  CON IMPUESTO
                                </label>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                style={{ width: "15%" }}
                                className="text-center"
                              >
                                {precioSelect === "1" && (
                                  <i className="fas fa-arrow-right text-danger"></i>
                                )}{" "}
                                Maximo: <b>{monedaCambio.simbolo}</b>
                              </td>
                              <td
                                style={{
                                  width: "12%",
                                }}
                              >
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  style={{
                                    color: "#000000",
                                  }}
                                  id="preciomaximo"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                  ref={txtPrecioMaxiSinImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                              <td style={{ width: "12%" }}>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  ref={txtUtilidadMaxi}
                                  className="form-control form-control-sm text-right fs-6"
                                  id="utilidadMaxi"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                ></input>
                              </td>
                              <td
                                className="border-right"
                                style={{ width: "15%" }}
                              >
                                <input
                                  type="text"
                                  disabled
                                  ref={txtPrecioMaxiConImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ width: "15%" }}
                                className="text-center"
                              >
                                {precioSelect === "2" && (
                                  <i className="fas fa-arrow-right text-danger"></i>
                                )}{" "}
                                Oferta: <b>{monedaCambio.simbolo}</b>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  style={{
                                    color: "#000000",
                                  }}
                                  id="preciooferta"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                  ref={txtPrecioOfeSinImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  ref={txtUtilidadOfe}
                                  className="form-control form-control-sm text-right fs-6"
                                  id="utilidadOfe"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                ></input>
                              </td>
                              <td className="border-right">
                                <input
                                  type="text"
                                  disabled
                                  ref={txtPrecioOfeConImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ width: "15%" }}
                                className="text-center"
                              >
                                {precioSelect === "3" && (
                                  <i className="fas fa-arrow-right text-danger"></i>
                                )}{" "}
                                Mayor: <b>{monedaCambio.simbolo}</b>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  style={{
                                    color: "#000000",
                                  }}
                                  id="preciomayor"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                  ref={txtPrecioMayorSinImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  ref={txtUtilidadMayor}
                                  className="form-control form-control-sm text-right fs-6"
                                  id="utilidadMayor"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                ></input>
                              </td>
                              <td className="border-right">
                                <input
                                  type="text"
                                  disabled
                                  ref={txtPrecioMayorConImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{ width: "15%" }}
                                className="text-center"
                              >
                                {precioSelect === "4" && (
                                  <i className="fas fa-arrow-right text-danger"></i>
                                )}{" "}
                                Minimo: <b>{monedaCambio.simbolo}</b>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  style={{
                                    color: "#000000",
                                  }}
                                  id="preciominimo"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                  ref={txtPrecioMiniSinImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  disabled={habilitado}
                                  ref={txtUtilidadMini}
                                  className="form-control form-control-sm text-right fs-6"
                                  id="utilidadMini"
                                  onFocus={seleccionarCampo}
                                  onKeyUp={handleInputMontoChange}
                                  onBlur={handleInputMontoChange}
                                ></input>
                              </td>
                              <td className="border-right">
                                <input
                                  type="text"
                                  disabled
                                  ref={txtPrecioMiniConImp}
                                  className="form-control form-control-sm text-right fs-6"
                                ></input>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </fieldset>
                    </div>
                  </div>

                  <div className="col-md-12 row mx-auto m-0 mb-1">
                    <div className="col-5 ml-auto">
                      <div className="row align-items-center rounded py-1">
                        <span className=" fw-bold col-md-6 mb-0 fs-6">
                          Unidad Alterna
                        </span>
                        <div className="col row align-items-center">
                          <div className="form-check col">
                            <input
                              className="form-check-input mt-0"
                              type="radio"
                              disabled={habilitado}
                              ref={radioSi}
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                              onChange={unidadAlterna}
                            />
                            <label
                              className="form-check-label fs-6"
                              htmlFor="flexRadioDefault1"
                            >
                              Si
                            </label>
                          </div>
                        </div>
                        <div className="col row align-items-center">
                          <div className="form-check col">
                            <input
                              className="form-check-input mt-0"
                              type="radio"
                              disabled={habilitado}
                              ref={radioNo}
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                              onChange={unidadAlterna}
                            />
                            <label
                              className="form-check-label fs-6"
                              htmlFor="flexRadioDefault1"
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* AQUI */}

              <div
                className={tabPanel.tab2}
                id="ex-with-icons-tabs-2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <div
                  className="col-md-12 row m-0 px-0"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <div className="col-md-12 row mx-auto bg-light rounded shadow py-3">
                    <div className="col-md-12 mx-auto mb-">
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between">
                        <legend
                          className="float-none w-auto fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Configuración
                        </legend>

                        <div className="input-group input-group-sm mb-2 col-md-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            UNID. PRINCIPAL:
                          </label>
                          <select
                            disabled={habilitadoAlter}
                            ref={cmbUniPrincipal}
                            className="form-select form-select-sm "
                            aria-label=".form-select-sm example"
                            name="unidadP"
                            onChange={onChange}
                          >
                            <option value="">--seleccione--</option>
                            {unidadM &&
                              unidadM.map((unimedi) => (
                                <option
                                  key={unimedi.idunidadmedida}
                                  value={unimedi.idunidadmedida}
                                >
                                  {" "}
                                  {unimedi.descripcion}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            UNID. ALTERNA:
                          </label>
                          <select
                            disabled={habilitadoAlter}
                            ref={cmbUniAlterna}
                            className="form-select form-select-sm "
                            aria-label=".form-select-sm example"
                            name="unidadA"
                            onChange={onChange}
                          >
                            {unidadM &&
                              unidadM.map((unimedi) => (
                                <option
                                  key={unimedi.idunidadmedida}
                                  value={unimedi.idunidadmedida}
                                >
                                  {" "}
                                  {unimedi.descripcion}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            UNID. VENTA:
                          </label>
                          <select
                            disabled={habilitadoAlter}
                            ref={cmbUniVenta}
                            className="form-select form-select-sm "
                            aria-label=".form-select-sm example"
                          >
                            {unidadV &&
                              unidadV.map((univ) => (
                                <option
                                  key={univ.idunidadmedida}
                                  value={univ.idunidadmedida}
                                >
                                  {univ.descripcion}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-7">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            {" "}
                            FACTOR CONVERSION:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            disabled={habilitadoAlter}
                            ref={txtFactor}
                            className="form-control col-md-3 form-control-sm text-right fs-6"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            id="factorConver"
                            onFocus={seleccionarCampo}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                          />
                          <label className="px-2">x</label>
                          <select
                            disabled={habilitadoAlter}
                            ref={cmbUniFactor}
                            className="form-select form-select-sm "
                            aria-label=".form-select-sm example"
                            name="unifactor"
                            onChange={onChange}
                          >
                            {factor &&
                              factor.map((fac) => (
                                <option key={fac.iduni} value={fac.iduni}>
                                  {" "}
                                  {fac.descripcion}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            UNID. COMPRA:
                          </label>
                          <select
                            disabled={habilitadoAlter}
                            ref={cmbUniCompra}
                            className="form-select form-select-sm "
                            aria-label=".form-select-sm example"
                          >
                            {unidadC &&
                              unidadC.map((unic) => (
                                <option
                                  key={unic.idunidadmedida}
                                  value={unic.idunidadmedida}
                                >
                                  {unic.descripcion}
                                </option>
                              ))}
                          </select>
                        </div>
                      </fieldset>
                    </div>
                    <div className="input-group input-group-sm mb-2 col-md-8"></div>
                    <div className="input-group input-group-sm mb-1 col-md-5 ml-auto">
                      <button
                        className="btn btn-primary w-100"
                        id="inputGroup-sizing-sm"
                        onClick={() => {
                          txtUtilidadMaxiAlter.current.value =
                            txtUtilidadMaxi.current.value;
                          txtUtilidadOfeAlter.current.value =
                            txtUtilidadOfe.current.value;
                          txtUtilidadMayorAlter.current.value =
                            txtUtilidadMayor.current.value;
                          txtUtilidadMiniAlter.current.value =
                            txtUtilidadMini.current.value;
                          txtPrecioMaxiSinImpAlter.current.style.color =
                            txtPrecioMaxiSinImp.current.style.color;
                          txtPrecioOfeSinImpAlter.current.style.color =
                            txtPrecioOfeSinImp.current.style.color;
                          txtPrecioMayorSinImpAlter.current.style.color =
                            txtPrecioMayorSinImp.current.style.color;
                          txtPrecioMiniSinImpAlter.current.style.color =
                            txtPrecioMiniSinImp.current.style.color;
                          calcularUtilidadAlter(5);
                        }}
                      >
                        <i className="fas fa-exchange-alt">
                          {" "}
                          APLICAR % DE UTILIDAD DE LA UNIDAD PRINCIPAL
                        </i>
                      </button>
                    </div>
                    <div className="col-md-12 mx-auto row mt-2 mb-2">
                      <div className="col-md-6 px-0">
                        <fieldset className="row col-sm-12 border-azul rounded d-flex justify-content-between">
                          <table className="table table-sm col-md-12 border bg-light">
                            <thead className="azulGradiant text-light fw-bold">
                              <tr>
                                <th className="text-center" scope="col">
                                  <label style={{ fontSize: "11px" }}>
                                    COSTOS
                                  </label>
                                </th>
                                <th className="text-center" scope="col">
                                  <label style={{ fontSize: "11px" }}>
                                    SIN IMPUESTO
                                  </label>
                                </th>
                                <th
                                  className="text-center border-right border-light"
                                  scope="col"
                                >
                                  <label style={{ fontSize: "11px" }}>
                                    CON IMPUESTO
                                  </label>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="text-center border-left">
                                  {costoSelect === "1" && (
                                    <i className="fas fa-arrow-right text-danger"></i>
                                  )}{" "}
                                  Costo Proveedor:{" "}
                                  <b>{monedaCambio.simbolo}</b>
                                </td>
                                <td style={{ width: "30%" }}>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    ref={txtCostoProveSinImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                    id="costoProveSinImpuAlter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                  ></input>
                                </td>
                                <td
                                  className="border-right"
                                  style={{ width: "30%" }}
                                >
                                  <input
                                    type="text"
                                    disabled
                                    ref={txtCostoProveConImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center border-left">
                                  {costoSelect === "2" && (
                                    <i className="fas fa-arrow-right text-danger"></i>
                                  )}{" "}
                                  Costo Calculado:{" "}
                                  <b>{monedaCambio.simbolo}</b>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    ref={txtCostoCalcuSinImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                    id="costoCalcuSinImpuAlter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                  ></input>
                                </td>
                                <td className="border-right">
                                  <input
                                    type="text"
                                    disabled
                                    ref={txtCostoCalcuConImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center border-left">
                                  {costoSelect === "3" && (
                                    <i className="fas fa-arrow-right text-danger"></i>
                                  )}{" "}
                                  Ultimo Costo: <b>{monedaCambio.simbolo}</b>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    ref={txtUltimoCostoSinImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                    id="costoUltiSinImpuAlter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                  ></input>
                                </td>
                                <td className="border-right">
                                  <input
                                    type="text"
                                    disabled
                                    ref={txtUltimoCostoConImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                              </tr>
                              <tr>
                                <td className="text-center border-left">
                                  {costoSelect === "4" && (
                                    <i className="fas fa-arrow-right text-danger"></i>
                                  )}{" "}
                                  Costo Promedio:{" "}
                                  <b>{monedaCambio.simbolo}</b>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    ref={txtCostoPromeSinImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                    id="costoPromeSinImpuAlter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                  ></input>
                                </td>
                                <td className="border-right">
                                  <input
                                    type="text"
                                    disabled
                                    ref={txtCostoPromeConImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </fieldset>
                      </div>

                      <div className="col-md-6 px-0">
                        <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between">
                          <table className="table table-sm col-md-12 border bg-light">
                            <thead className="azulGradiant text-light fw-bold">
                              <tr>
                                <th className="text-center" scope="col">
                                  <label style={{ fontSize: "11px" }}>
                                    PRECIOS
                                  </label>
                                </th>
                                <th className="text-center " scope="col">
                                  <label style={{ fontSize: "11px" }}>
                                    SIN IMPUESTO
                                  </label>
                                </th>
                                <th className="text-center" scope="col">
                                  <label style={{ fontSize: "11px" }}>
                                    UTILIDAD %
                                  </label>
                                </th>
                                <th className="text-center" scope="col">
                                  <label style={{ fontSize: "11px" }}>
                                    CON IMPUESTO
                                  </label>
                                  {/* <span>Aplicar % de Utilidad de la Unidad Principal</span> */}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  style={{ width: "15%" }}
                                  className="text-center"
                                >
                                  {precioSelect === "1" && (
                                    <i className="fas fa-arrow-right text-danger"></i>
                                  )}{" "}
                                  Maximo: <b>{monedaCambio.simbolo}</b>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    style={{
                                      color: "#000000",
                                    }}
                                    id="preciomaximoalter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                    ref={txtPrecioMaxiSinImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                                <td style={{ width: "12%" }}>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    ref={txtUtilidadMaxiAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                    id="utilidadMaxiAlter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                  ></input>
                                </td>
                                <td
                                  className="border-right"
                                  style={{ width: "18%" }}
                                >
                                  <input
                                    type="text"
                                    disabled
                                    ref={txtPrecioMaxiConImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{ width: "15%" }}
                                  className="text-center"
                                >
                                  {precioSelect === "2" && (
                                    <i className="fas fa-arrow-right text-danger"></i>
                                  )}{" "}
                                  Oferta: <b>{monedaCambio.simbolo}</b>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    style={{
                                      color: "#000000",
                                    }}
                                    id="precioofertaalter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                    ref={txtPrecioOfeSinImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    ref={txtUtilidadOfeAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                    id="utilidadOfeAlter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                  ></input>
                                </td>
                                <td className="border-right">
                                  <input
                                    type="text"
                                    disabled
                                    ref={txtPrecioOfeConImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{ width: "15%" }}
                                  className="text-center"
                                >
                                  {precioSelect === "3" && (
                                    <i className="fas fa-arrow-right text-danger"></i>
                                  )}{" "}
                                  Mayor: <b>{monedaCambio.simbolo}</b>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    id="preciomayoralter"
                                    style={{
                                      color: "#000000",
                                    }}
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                    ref={txtPrecioMayorSinImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    ref={txtUtilidadMayorAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                    id="utilidadMayorAlter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                  ></input>
                                </td>
                                <td className="border-right">
                                  <input
                                    type="text"
                                    disabled
                                    ref={txtPrecioMayorConImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{ width: "15%" }}
                                  className="text-center"
                                >
                                  {precioSelect === "4" && (
                                    <i className="fas fa-arrow-right text-danger"></i>
                                  )}{" "}
                                  Minimo: <b>{monedaCambio.simbolo}</b>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    id="preciominialter"
                                    style={{
                                      color: "#000000",
                                    }}
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                    ref={txtPrecioMiniSinImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    disabled={habilitadoAlter}
                                    ref={txtUtilidadMiniAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                    id="utilidadMiniAlter"
                                    onFocus={seleccionarCampo}
                                    onKeyUp={handleInputMontoChange}
                                    onBlur={handleInputMontoChange}
                                  ></input>
                                </td>
                                <td className="border-right">
                                  <input
                                    type="text"
                                    disabled
                                    ref={txtPrecioMiniConImpAlter}
                                    className="form-control form-control-sm text-right fs-6"
                                  ></input>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="ex-with-icons-tabs-3"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-3"
              ></div>
            </div>
          </div>
        </div>


      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAceptar} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success mx-1"><i className="fas fa-check-circle">  Modificar</i></button>
            <button onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      <GestionarMarca
        show={mostrarMarca}
        onHideCancela={() => {
          setMostrarMarca(false);
        }}
        onHideRenderizar={seleccionarMarca}
        llamado={2}
      />

      <GestionarModelo
        show={mostrarModelo}
        onHideCancela={() => {
          setMostrarModelo(false);
        }}
        onHideRenderizar={seleccionarModelo}
        llamado={2}
      />
      <GestionarTipoProducto
        show={mostrarTipoP}
        onHideCancela={() => {
          setMostrarTipoP(false);
        }}
        onHideRenderizar={seleccionarTipoProd}
        llamado={2}
      />
      <GestionarFabricantes
        show={mostrarFabricante}
        onHideCancela={() => {
          setMostrarFabricante(false);
        }}
        onHideRenderizar={seleccionarFabricante}
        llamado={2}
      />
      <GestionarClasificadorVacios
        show={mostrarclassvacio}
        onHideCancela={() => {
          setMostrarclassvacio(false);
        }}
        onHideRenderizar={seleccionarClassVacios}
        llamado={2}
      />
      <GestionarMedida
        show={mostrarMedida}
        onHideRenderizar={agregarUnidad}
        onHideCancela={() => {
          setMostrarMedida(false);
        }}
        llamado={2}
      />
      {/* <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      /> */}
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/almacen/modalEditarProductoporOpe.js